// Board Exam - Infection Control and Safety
// Complete file with all 2 topics and questions

export const questions = {
  "1. Infection Control": [
    {
      id: 15100,
      question: "What is the primary objective of infection prevention and control in healthcare settings?",
      options: [
        "To prevent healthcare-associated infections in patients and occupational injuries in personnel",
        "To eliminate all microorganisms from the environment",
        "To identify all patients with infectious diseases",
        "To reduce the cost of healthcare delivery"
      ],
      correct: "A"
    },
    {
      id: 15101,
      question: "What does IPC stand for?",
      options: [
        "Internal Patient Care",
        "Infection Prevention and Control",
        "Institutional Practice Committee",
        "Invasive Procedure Control"
      ],
      correct: "B"
    },
    {
      id: 15102,
      question: "What is a healthcare-associated infection (HAI)?",
      options: [
        "An infection acquired in the community",
        "An infection present before hospital admission",
        "An infection acquired by patients during healthcare delivery",
        "An infection that only affects healthcare workers"
      ],
      correct: "C"
    },
    {
      id: 15103,
      question: "Which statement best describes the infection-control model?",
      options: [
        "It is identical to the traditional patient care model",
        "It focuses on tasks and procedures to protect both patient and provider",
        "It relies solely on patient health histories",
        "It only protects the healthcare provider"
      ],
      correct: "B"
    },
    {
      id: 15104,
      question: "Why doesn\'t scrutinizing individual health histories determine the degree of risk for disease transmission?",
      options: [
        "Health histories are always incomplete",
        "Patients may be unknowingly infected and display no symptoms",
        "Health histories are too time-consuming",
        "Healthcare workers cannot read health histories"
      ],
      correct: "B"
    },
    {
      id: 15105,
      question: "Which agency develops infection-control guidelines but does NOT enforce them?",
      options: [
        "OSHA",
        "FDA",
        "CDC",
        "EPA"
      ],
      correct: "C"
    },
    {
      id: 15106,
      question: "What is the CDC\'s primary mission?",
      options: [
        "To regulate medical devices",
        "To promote health and quality of life by preventing and controlling disease",
        "To enforce workplace safety regulations",
        "To regulate chemical germicides"
      ],
      correct: "B"
    },
    {
      id: 15107,
      question: "Which agency enforces workplace safety regulations including those for IPC in healthcare settings?",
      options: [
        "CDC",
        "EPA",
        "FDA",
        "OSHA"
      ],
      correct: "D"
    },
    {
      id: 15108,
      question: "What does OSHA stand for?",
      options: [
        "Organization for Safety and Health Administration",
        "Occupational Safety and Health Administration",
        "Office of Safety and Hazard Assessment",
        "Operational Standards for Healthcare Activities"
      ],
      correct: "B"
    },
    {
      id: 15109,
      question: "Which agency regulates medical devices from simple items to complex technologies?",
      options: [
        "CDC",
        "EPA",
        "FDA",
        "OSHA"
      ],
      correct: "C"
    },
    {
      id: 15110,
      question: "What is the EPA\'s regulatory mission since 1970?",
      options: [
        "To promote vaccination programs",
        "To enforce bloodborne pathogen standards",
        "To protect human health and the environment",
        "To develop infection control guidelines"
      ],
      correct: "C"
    },
    {
      id: 15111,
      question: "What is the standard of care in infection control?",
      options: [
        "The maximum level of care possible",
        "The minimum level acceptable in all aspects of patient care",
        "Care provided only in hospital settings",
        "Care determined by individual practitioners"
      ],
      correct: "B"
    },
    {
      id: 15112,
      question: "What determines the standard of care for infection-control practices?",
      options: [
        "Individual practitioner preference only",
        "Patient requests",
        "Regulations, evidence-based guidelines, government agencies, licensing boards, and expert opinion",
        "Cost considerations"
      ],
      correct: "C"
    },
    {
      id: 15113,
      question: "Which pathogen can be transmitted in dental healthcare settings?",
      options: [
        "Only bacteria",
        "Only viruses",
        "Pathogens including HBV, HCV, HIV, TB, staphylococci, streptococci, influenza, and coronavirus",
        "Only bloodborne pathogens"
      ],
      correct: "C"
    },
    {
      id: 15114,
      question: "What are the routes of transmission in dental settings?",
      options: [
        "Airborne transmission only",
        "Direct contact, indirect contact, droplet contact, and inhalation of airborne microorganisms",
        "Only through blood exposure",
        "Through contaminated food and water"
      ],
      correct: "B"
    },
    {
      id: 15115,
      question: "What conditions must be present for infection to occur?",
      options: [
        "Only a pathogenic organism",
        "Only a susceptible host",
        "Pathogenic organism, reservoir, mode of transmission, portal of entry, and susceptible host",
        "Only a mode of transmission"
      ],
      correct: "C"
    },
    {
      id: 15116,
      question: "How do effective infection-control strategies prevent disease transmission?",
      options: [
        "By treating all infected patients",
        "By interrupting one or more links in the chain of infection",
        "By isolating all patients",
        "By using antibiotics prophylactically"
      ],
      correct: "B"
    },
    {
      id: 15117,
      question: "How many principles of IPC does the CDC identify?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five"
      ],
      correct: "C"
    },
    {
      id: 15118,
      question: "What is Principle 1 of IPC?",
      options: [
        "Avoid contact with blood",
        "Take action to stay healthy",
        "Make patient care items safe",
        "Limit the spread of contamination"
      ],
      correct: "B"
    },
    {
      id: 15119,
      question: "What should a personnel health program include according to CDC guidelines?",
      options: [
        "Only immunizations",
        "Hand hygiene, medical evaluation, training, work-related illness management, postexposure management, and immunization",
        "Only annual physical exams",
        "Only infection control training"
      ],
      correct: "B"
    },
    {
      id: 15120,
      question: "What is one of the most effective means of preventing disease transmission?",
      options: [
        "Wearing gloves at all times",
        "Using antibiotics",
        "Immunization",
        "Isolating all patients"
      ],
      correct: "C"
    },
    {
      id: 15121,
      question: "Which vaccine is recommended annually for all healthcare personnel?",
      options: [
        "Hepatitis B",
        "MMR",
        "Influenza",
        "Varicella"
      ],
      correct: "C"
    },
    {
      id: 15122,
      question: "What does the HBV vaccine protect against?",
      options: [
        "Hepatitis A virus",
        "Hepatitis B virus",
        "Hepatitis C virus",
        "HIV"
      ],
      correct: "B"
    },
    {
      id: 15123,
      question: "How many doses are in the standard HBV vaccination series?",
      options: [
        "One",
        "Two",
        "Three",
        "Four"
      ],
      correct: "C"
    },
    {
      id: 15124,
      question: "When should anti-HBs testing be performed after HBV vaccination?",
      options: [
        "Immediately after the first dose",
        "Before starting the series",
        "1 to 2 months after the third dose",
        "One year after completion"
      ],
      correct: "C"
    },
    {
      id: 15125,
      question: "What does Tdap protect against?",
      options: [
        "Tuberculosis, diphtheria, and pertussis",
        "Tetanus, diphtheria, and acellular pertussis",
        "Typhoid, dengue, and plague",
        "Toxoplasmosis, diarrhea, and pneumonia"
      ],
      correct: "B"
    },
    {
      id: 15126,
      question: "How often should the Td booster be given?",
      options: [
        "Every 5 years",
        "Every 10 years",
        "Every 15 years",
        "Every 20 years"
      ],
      correct: "B"
    },
    {
      id: 15127,
      question: "What should HCP with active tuberculosis do?",
      options: [
        "Continue working with a mask",
        "Refrain from working until illness resolves",
        "Work only with adult patients",
        "Take antibiotics while working"
      ],
      correct: "B"
    },
    {
      id: 15128,
      question: "What should HCP with measles or mumps do?",
      options: [
        "Continue working with precautions",
        "Work only half days",
        "Refrain from working during acute illness and after exposure if not immunized",
        "Wear an N95 mask while working"
      ],
      correct: "C"
    },
    {
      id: 15129,
      question: "What is Principle 2 of IPC?",
      options: [
        "Take action to stay healthy",
        "Avoid contact with blood and other infectious body substances",
        "Make patient care items safe",
        "Limit environmental contamination"
      ],
      correct: "B"
    },
    {
      id: 15130,
      question: "What does PPE stand for?",
      options: [
        "Professional Practice Equipment",
        "Personal Protective Equipment",
        "Primary Prevention Essentials",
        "Patient Protection Elements"
      ],
      correct: "B"
    },
    {
      id: 15131,
      question: "What do standard precautions require?",
      options: [
        "Different protocols for different patients",
        "The same protocols for all patients regardless of infectious status",
        "Extra precautions only for known infected patients",
        "Precautions based on health history"
      ],
      correct: "B"
    },
    {
      id: 15132,
      question: "Why don\'t standard precautions depend on health history?",
      options: [
        "Health histories are unreliable",
        "Infected individuals may be unaware of their status or choose not to disclose",
        "Health histories take too long to review",
        "DHCP are not trained to interpret health histories"
      ],
      correct: "B"
    },
    {
      id: 15133,
      question: "To what do standard precautions apply?",
      options: [
        "Blood only",
        "All body fluids except sweat and tears",
        "Only visibly contaminated fluids",
        "Only bloodborne pathogens"
      ],
      correct: "B"
    },
    {
      id: 15134,
      question: "What are transmission-based precautions?",
      options: [
        "Replacements for standard precautions",
        "Measures in addition to standard precautions based on route of transmission",
        "Precautions used instead of PPE",
        "Precautions only for surgical procedures"
      ],
      correct: "B"
    },
    {
      id: 15135,
      question: "What are the three categories of transmission-based precautions?",
      options: [
        "Blood, saliva, and respiratory",
        "Contact, droplet, and airborne",
        "Gloves, masks, and gowns",
        "Patient, provider, and environmental"
      ],
      correct: "B"
    },
    {
      id: 15136,
      question: "For clinically active TB, what type of precautions are needed?",
      options: [
        "Standard precautions only",
        "Contact precautions",
        "A hierarchy including administrative controls, environmental controls, and respiratory protection",
        "Droplet precautions only"
      ],
      correct: "C"
    },
    {
      id: 15137,
      question: "What should be done for patients with active TB?",
      options: [
        "Treat immediately in the regular operatory",
        "Evaluate away from others, defer elective treatment, refer urgent treatment to appropriate facility",
        "Provide treatment with standard precautions",
        "Refuse all treatment"
      ],
      correct: "B"
    },
    {
      id: 15138,
      question: "What are signs and symptoms of TB?",
      options: [
        "Rash and fever only",
        "Coughing, chest pain, sweating, weight loss, night sweats, and fever",
        "Headache and nausea",
        "Joint pain and fatigue"
      ],
      correct: "B"
    },
    {
      id: 15139,
      question: "What type of control is considered most effective in reducing workplace injury risk?",
      options: [
        "Administrative controls",
        "Work practice controls",
        "Engineering controls",
        "Personal protective equipment"
      ],
      correct: "C"
    },
    {
      id: 15140,
      question: "What are examples of engineering controls?",
      options: [
        "Training programs",
        "Written policies",
        "Devices with retractable needles, shielding mechanisms, and sharps disposal containers",
        "Hand hygiene protocols"
      ],
      correct: "C"
    },
    {
      id: 15141,
      question: "When should engineering controls be used?",
      options: [
        "Only when required by law",
        "When reasonable to believe they will reduce exposure potential",
        "Only in surgical settings",
        "Only for high-risk procedures"
      ],
      correct: "B"
    },
    {
      id: 15142,
      question: "What are work practice controls?",
      options: [
        "Devices that reduce hazards",
        "Administrative policies",
        "Precautionary measures that alter how a task is performed",
        "Equipment maintenance procedures"
      ],
      correct: "C"
    },
    {
      id: 15143,
      question: "What is an example of a work practice control?",
      options: [
        "An autoclave",
        "A sharps container",
        "Using a stabilized sponge instead of gauze wrapped around a finger",
        "A face shield"
      ],
      correct: "C"
    },
    {
      id: 15144,
      question: "What is the one-handed scoop technique used for?",
      options: [
        "Removing sutures",
        "Recapping used anesthetic needles",
        "Cleaning instruments",
        "Applying topical anesthetic"
      ],
      correct: "B"
    },
    {
      id: 15145,
      question: "What percentage of exposures in dental settings are associated with needles or sharps?",
      options: [
        "50%",
        "70%",
        "More than 90%",
        "100%"
      ],
      correct: "C"
    },
    {
      id: 15146,
      question: "Where do most transmissions in dental settings occur?",
      options: [
        "In the mouth",
        "Outside the mouth on hands and fingers",
        "In the operatory air",
        "On environmental surfaces"
      ],
      correct: "B"
    },
    {
      id: 15147,
      question: "What are administrative controls?",
      options: [
        "Equipment that prevents hazards",
        "Techniques for performing procedures",
        "Actions taken to reduce or eliminate a hazard",
        "Sterilization protocols"
      ],
      correct: "C"
    },
    {
      id: 15148,
      question: "What does appropriate PPE protect?",
      options: [
        "Only the hands",
        "Only the face",
        "Skin, clothing, eyes, mouth, and other mucous membranes",
        "Only against bloodborne pathogens"
      ],
      correct: "C"
    },
    {
      id: 15149,
      question: "On what should PPE selection be based?",
      options: [
        "Cost considerations",
        "The nature of the procedure and anticipated exposure risks",
        "Patient preference",
        "Time of day"
      ],
      correct: "B"
    },
    {
      id: 15150,
      question: "Should PPE selection be based on the patient\'s infectious disease status?",
      options: [
        "Yes, always",
        "Yes, for certain diseases",
        "No, infection-control precautions should be the same for each patient",
        "Only for surgical procedures"
      ],
      correct: "C"
    },
    {
      id: 15151,
      question: "What is appropriate eye protection?",
      options: [
        "Reading glasses only",
        "Goggles, glasses with solid side shields, or face shield",
        "Sunglasses",
        "Contact lenses"
      ],
      correct: "B"
    },
    {
      id: 15152,
      question: "Must prescription eyewear meet standards for protective eyewear?",
      options: [
        "No, prescription glasses are always adequate",
        "Yes, or goggles/face shields should be worn over them",
        "Only for surgical procedures",
        "Only if the patient has a known infection"
      ],
      correct: "B"
    },
    {
      id: 15153,
      question: "What additional eye protection is required for laser use?",
      options: [
        "None if wearing regular protective eyewear",
        "Laser-specific goggles with labeled wavelengths and optical density",
        "Darker tinted glasses",
        "Double layers of regular protective eyewear"
      ],
      correct: "B"
    },
    {
      id: 15154,
      question: "What does a surgical mask protect?",
      options: [
        "Only the nose",
        "Only the mouth",
        "The mucous membranes of the nose and mouth from spatter",
        "Against all airborne pathogens"
      ],
      correct: "C"
    },
    {
      id: 15155,
      question: "How are surgical face masks classified?",
      options: [
        "By size only",
        "By color",
        "By performance classes based on fluid resistance and filtration efficiency",
        "By manufacturer only"
      ],
      correct: "C"
    },
    {
      id: 15156,
      question: "What are the ASTM rating designations for surgical masks?",
      options: [
        "Types A, B, and C",
        "Classes 1, 2, and 3",
        "Levels 1, 2, and 3",
        "Grades Low, Medium, and High"
      ],
      correct: "C"
    },
    {
      id: 15157,
      question: "Which level mask has the lowest barrier performance?",
      options: [
        "Level 3",
        "Level 2",
        "Level 1",
        "All levels are equal"
      ],
      correct: "C"
    },
    {
      id: 15158,
      question: "When should a level 2 or 3 mask be considered?",
      options: [
        "For all procedures",
        "For procedures likely to produce splatter, excess moisture, or higher velocity",
        "Only for surgical procedures",
        "Never, level 1 is always adequate"
      ],
      correct: "B"
    },
    {
      id: 15159,
      question: "What provides greater protection for the respiratory system than a face mask?",
      options: [
        "Double masking",
        "A face shield",
        "A respirator",
        "Protective eyewear"
      ],
      correct: "C"
    },
    {
      id: 15160,
      question: "What type of respirator is commonly recommended for aerosol-generating procedures?",
      options: [
        "N50",
        "N75",
        "N95",
        "N100"
      ],
      correct: "C"
    },
    {
      id: 15161,
      question: "What must a respiratory protection program include?",
      options: [
        "Only providing respirators",
        "Fit testing, medical evaluation, education, and training",
        "Only annual training",
        "Only medical evaluation"
      ],
      correct: "B"
    },
    {
      id: 15162,
      question: "What should protective clothing cover?",
      options: [
        "Only the torso",
        "Only the arms",
        "Personal clothing and skin including forearms",
        "Only the hands"
      ],
      correct: "C"
    },
    {
      id: 15163,
      question: "When should protective clothing be removed?",
      options: [
        "At the end of the day",
        "Before leaving the work area",
        "Only when visibly soiled",
        "Once per week"
      ],
      correct: "B"
    },
    {
      id: 15164,
      question: "Are scrubs alone considered protective attire?",
      options: [
        "Yes, always",
        "Yes, if they are clean",
        "No, they should be worn with a long-sleeved gown or lab coat",
        "Only in surgical settings"
      ],
      correct: "C"
    },
    {
      id: 15165,
      question: "Who must arrange for laundering reusable protective attire?",
      options: [
        "The employee",
        "The employer",
        "A third-party service",
        "It is optional"
      ],
      correct: "B"
    },
    {
      id: 15166,
      question: "What are the three categories of gloves used in dental procedures?",
      options: [
        "Small, medium, and large",
        "Latex, nitrile, and vinyl",
        "Medical examination, sterile surgeon\'s, and heavy-duty utility",
        "Powder-free, powdered, and textured"
      ],
      correct: "C"
    },
    {
      id: 15167,
      question: "When should medical gloves be worn?",
      options: [
        "Only during surgical procedures",
        "At all times in the dental office",
        "When potential exists for contacting blood, saliva, OPIM, or mucous membranes",
        "Only when treating known infected patients"
      ],
      correct: "C"
    },
    {
      id: 15168,
      question: "Should gloves be worn for each patient?",
      options: [
        "No, they can be reused if not visibly soiled",
        "Yes, a new pair for each patient",
        "Only if the patient requests",
        "Only for bloody procedures"
      ],
      correct: "B"
    },
    {
      id: 15169,
      question: "What should be done if gloves are torn, cut, or punctured?",
      options: [
        "Continue wearing them",
        "Cover with tape",
        "Remove them, wash hands, and reglove",
        "Wear double gloves next time"
      ],
      correct: "C"
    },
    {
      id: 15170,
      question: "What might cause dermatitis or allergic reactions from glove use?",
      options: [
        "Washing hands too frequently",
        "Contact with chemicals used in glove manufacture or latex proteins",
        "Applying lotion before donning gloves",
        "Gloves that are too large"
      ],
      correct: "B"
    },
    {
      id: 15171,
      question: "What should HCP experiencing dermal problems from gloves do?",
      options: [
        "Continue using the same gloves",
        "Apply more lotion",
        "Consult a qualified healthcare professional for diagnosis and treatment",
        "Stop wearing gloves"
      ],
      correct: "C"
    },
    {
      id: 15172,
      question: "What is the most important behavior in disease transmission prevention?",
      options: [
        "Wearing gloves",
        "Hand hygiene",
        "Wearing masks",
        "Environmental disinfection"
      ],
      correct: "B"
    },
    {
      id: 15173,
      question: "On what does the preferred hand hygiene method depend?",
      options: [
        "Time of day",
        "Type of procedure, degree of contamination, and desired antimicrobial persistence",
        "Personal preference",
        "Water temperature"
      ],
      correct: "B"
    },
    {
      id: 15174,
      question: "For routine dental procedures, how can hands be washed?",
      options: [
        "Only with antimicrobial soap",
        "With plain or antimicrobial soap and water, or alcohol-based hand rub if not visibly soiled",
        "Only with alcohol-based hand rub",
        "Only with water"
      ],
      correct: "B"
    },
    {
      id: 15175,
      question: "What type of hand hygiene is required for surgical procedures?",
      options: [
        "Routine handwashing",
        "Alcohol-based hand rub",
        "Surgical hand antisepsis",
        "Plain soap and water"
      ],
      correct: "C"
    },
    {
      id: 15176,
      question: "Should rings and hand jewelry be removed before hand hygiene?",
      options: [
        "No, they don\'t affect hand hygiene",
        "Only if visibly dirty",
        "Yes, they should be removed",
        "Only for surgical procedures"
      ],
      correct: "C"
    },
    {
      id: 15177,
      question: "Why should healthcare personnel keep fingernails short?",
      options: [
        "For appearance",
        "To allow thorough cleaning and prevent glove tears",
        "To save time",
        "It is not necessary"
      ],
      correct: "B"
    },
    {
      id: 15178,
      question: "Should healthcare personnel wear artificial fingernails when having direct patient contact?",
      options: [
        "Yes, if they are clean",
        "Yes, if they are short",
        "No, they should not wear artificial nails",
        "Only gel nails are acceptable"
      ],
      correct: "C"
    },
    {
      id: 15179,
      question: "What is Principle 3 of IPC?",
      options: [
        "Take action to stay healthy",
        "Avoid contact with blood",
        "Make patient care items safe for use",
        "Maintain hand hygiene"
      ],
      correct: "C"
    },
    {
      id: 15180,
      question: "What are patient care items classified as if they penetrate soft tissue or bone?",
      options: [
        "Semicritical",
        "Noncritical",
        "Critical",
        "High-risk"
      ],
      correct: "C"
    },
    {
      id: 15181,
      question: "How must critical instruments be managed between patients?",
      options: [
        "Wiped with disinfectant",
        "Heat sterilized or discarded if disposable",
        "Soaked in alcohol",
        "Rinsed with water"
      ],
      correct: "B"
    },
    {
      id: 15182,
      question: "What are examples of critical instruments?",
      options: [
        "Blood pressure cuffs",
        "Mouth mirrors",
        "Periodontal probes, explorers, scalers, and ultrasonic scaler tips",
        "X-ray cones"
      ],
      correct: "C"
    },
    {
      id: 15183,
      question: "What are semicritical instruments?",
      options: [
        "Instruments that penetrate soft tissue",
        "Instruments that do not penetrate tissue but contact oral fluids",
        "Instruments that only contact intact skin",
        "Instruments that are never contaminated"
      ],
      correct: "B"
    },
    {
      id: 15184,
      question: "How should semicritical instruments be managed?",
      options: [
        "Low-level disinfection",
        "Heat sterilized or high-level disinfection if heat sterilization not possible",
        "Wiped clean only",
        "Rinsed with water"
      ],
      correct: "B"
    },
    {
      id: 15185,
      question: "What are examples of semicritical instruments?",
      options: [
        "X-ray heads",
        "Light handles",
        "Mouth mirrors, ultrasonic handpieces, impression trays",
        "Chairs and countertops"
      ],
      correct: "C"
    },
    {
      id: 15186,
      question: "What are noncritical instruments?",
      options: [
        "Instruments that penetrate tissue",
        "Instruments that contact mucous membranes",
        "Items that contact only intact skin",
        "Instruments used in surgery"
      ],
      correct: "C"
    },
    {
      id: 15187,
      question: "How should noncritical items be managed?",
      options: [
        "Heat sterilization",
        "High-level disinfection",
        "Surface barriers or low- to intermediate-level disinfection",
        "No cleaning needed"
      ],
      correct: "C"
    },
    {
      id: 15188,
      question: "What is sterilization?",
      options: [
        "Removal of visible dirt",
        "Destruction of most organisms",
        "Destruction of all living organisms including bacterial spores",
        "Disinfection with chemicals"
      ],
      correct: "C"
    },
    {
      id: 15189,
      question: "What provides the highest level of assurance that no pathogenic organisms remain?",
      options: [
        "Disinfection only",
        "Properly performed cleaning and sterilization",
        "Wiping with alcohol",
        "Air drying"
      ],
      correct: "B"
    },
    {
      id: 15190,
      question: "How should sterilization areas be arranged?",
      options: [
        "In a random pattern",
        "To encourage a one-directional workflow",
        "For maximum storage",
        "Near the reception area"
      ],
      correct: "B"
    },
    {
      id: 15191,
      question: "In what type of container should used instruments be transported?",
      options: [
        "Open tray",
        "Plastic bag",
        "Container solid on sides and bottom labeled with biohazard symbol",
        "Paper bag"
      ],
      correct: "C"
    },
    {
      id: 15192,
      question: "What PPE should be worn throughout instrument processing?",
      options: [
        "Gloves only",
        "Mask only",
        "Heavy-duty gloves, face protection, and gown or lab coat",
        "Shoe covers only"
      ],
      correct: "C"
    },
    {
      id: 15193,
      question: "What is the most effective means of cleaning instruments before sterilization?",
      options: [
        "Hand scrubbing",
        "Automated devices like ultrasonic cleaners or instrument washers",
        "Soaking in water",
        "Wiping with gauze"
      ],
      correct: "B"
    },
    {
      id: 15194,
      question: "What should be used for heavily soiled instruments?",
      options: [
        "Extra hot water",
        "A product containing enzyme for presoak or prespray",
        "Bleach solution",
        "Alcohol"
      ],
      correct: "B"
    },
    {
      id: 15195,
      question: "After cleaning, what should be done with instruments?",
      options: [
        "Air dried and stored",
        "Inspected for debris, placed in sterilization pouches or wrapped trays",
        "Used immediately",
        "Soaked in water"
      ],
      correct: "B"
    },
    {
      id: 15196,
      question: "How should instrument packs be placed in the sterilizer?",
      options: [
        "Stacked tightly",
        "In single layer or loosely on sides",
        "Completely overlapping",
        "Standing upright only"
      ],
      correct: "B"
    },
    {
      id: 15197,
      question: "Where should sterilized instrument packs be stored?",
      options: [
        "In a humid area",
        "Near the sink",
        "In a dry area away from contamination",
        "In the operatory"
      ],
      correct: "C"
    },
    {
      id: 15198,
      question: "What is the most common method of heat sterilization in dental offices?",
      options: [
        "Dry heat",
        "Chemical vapor",
        "Steam autoclave",
        "Flash sterilization"
      ],
      correct: "C"
    },
    {
      id: 15199,
      question: "What does a steam autoclave use to sterilize?",
      options: [
        "Dry heat only",
        "Steam in a pressurized chamber",
        "Chemical vapors",
        "Ultraviolet light"
      ],
      correct: "B"
    },
    {
      id: 15200,
      question: "What are the two methods of air evacuation in autoclaves?",
      options: [
        "Fast and slow",
        "Dynamic air removal and gravity displacement",
        "Steam and pressure",
        "Heat and cold"
      ],
      correct: "B"
    },
    {
      id: 15201,
      question: "What is more efficient at air removal?",
      options: [
        "Gravity displacement",
        "Dynamic air removal",
        "Both are equal",
        "Neither removes air"
      ],
      correct: "B"
    },
    {
      id: 15202,
      question: "What test should be conducted with dynamic air removal sterilizers?",
      options: [
        "Spore test only",
        "Chemical indicator only",
        "Air removal test such as Bowie-Dick test",
        "Temperature test only"
      ],
      correct: "C"
    },
    {
      id: 15203,
      question: "When should the Bowie-Dick test be performed?",
      options: [
        "Weekly",
        "Monthly",
        "At the beginning of each day",
        "Annually"
      ],
      correct: "C"
    },
    {
      id: 15204,
      question: "What might result from incomplete air removal?",
      options: [
        "Faster sterilization",
        "Incomplete sterilization of contents",
        "Equipment damage",
        "No effect on sterilization"
      ],
      correct: "B"
    },
    {
      id: 15205,
      question: "What does an unsaturated chemical vapor sterilizer use?",
      options: [
        "Steam",
        "Dry heat",
        "Chemical vapor in a pressurized chamber",
        "Moist heat"
      ],
      correct: "C"
    },
    {
      id: 15206,
      question: "What advantage does chemical vapor sterilization offer?",
      options: [
        "Faster cycles",
        "Lower temperature",
        "Reduced humidity reducing rust and corrosion",
        "No maintenance needed"
      ],
      correct: "C"
    },
    {
      id: 15207,
      question: "What is a disadvantage of dry-heat sterilization?",
      options: [
        "It is too slow",
        "High temperatures may damage heat-sensitive items",
        "It requires water",
        "It is not effective"
      ],
      correct: "B"
    },
    {
      id: 15208,
      question: "Why does the CDC discourage use of chemical disinfectants for sterilization?",
      options: [
        "They are not effective",
        "They are too expensive",
        "Toxic properties and less reliability than heat sterilization",
        "They take too long"
      ],
      correct: "C"
    },
    {
      id: 15209,
      question: "What do chemical indicators show?",
      options: [
        "Complete sterilization",
        "Presence of necessary parameters like heat or steam",
        "Instrument cleanliness",
        "Water quality"
      ],
      correct: "B"
    },
    {
      id: 15210,
      question: "How many types of chemical indicators exist?",
      options: [
        "Two",
        "Four",
        "Six",
        "Eight"
      ],
      correct: "C"
    },
    {
      id: 15211,
      question: "Where should chemical indicators be used?",
      options: [
        "Only outside packages",
        "Inside every packet of instruments",
        "Only for surgical instruments",
        "They are not necessary"
      ],
      correct: "B"
    },
    {
      id: 15212,
      question: "What is the highest level of sterility assurance?",
      options: [
        "Chemical indicators",
        "Temperature monitoring",
        "Biologic indicators (spore tests)",
        "Visual inspection"
      ],
      correct: "C"
    },
    {
      id: 15213,
      question: "What do biologic indicators use?",
      options: [
        "Chemical strips",
        "Nonpathogenic spores resistant to sterilization",
        "Temperature sensors",
        "pH indicators"
      ],
      correct: "B"
    },
    {
      id: 15214,
      question: "What organism is used for testing steam and chemical vapor sterilization?",
      options: [
        "Bacillus pumilus",
        "Geobacillus stearothermophilus",
        "Escherichia coli",
        "Staphylococcus aureus"
      ],
      correct: "B"
    },
    {
      id: 15215,
      question: "What organism is most resistant to dry heat sterilization?",
      options: [
        "Geobacillus stearothermophilus",
        "Bacillus pumilus",
        "Clostridium difficile",
        "Mycobacterium tuberculosis"
      ],
      correct: "B"
    },
    {
      id: 15216,
      question: "How often should spore testing be performed?",
      options: [
        "Daily",
        "At least weekly and with each implantable device",
        "Monthly",
        "Annually"
      ],
      correct: "B"
    },
    {
      id: 15217,
      question: "Should records of spore testing be maintained?",
      options: [
        "No, they are not necessary",
        "Yes, and many states require this",
        "Only for hospital settings",
        "Only for the past year"
      ],
      correct: "B"
    },
    {
      id: 15218,
      question: "What is the EPA standard for heterotrophic bacteria in drinking water?",
      options: [
        "≤100 CFU/mL",
        "≤200 CFU/mL",
        "≤500 CFU/mL",
        "≤1000 CFU/mL"
      ],
      correct: "C"
    },
    {
      id: 15219,
      question: "What standard should dental unit output water meet for nonsurgical procedures?",
      options: [
        "Sterile water standards",
        "Distilled water standards",
        "Drinking water standards (≤500 CFU/mL)",
        "No specific standard"
      ],
      correct: "C"
    },
    {
      id: 15220,
      question: "Do independent water reservoirs alone prevent biofilm development?",
      options: [
        "Yes, completely",
        "No, they must be combined with other approaches",
        "Only if using distilled water",
        "Only if changed daily"
      ],
      correct: "B"
    },
    {
      id: 15221,
      question: "What should independent water reservoirs be combined with?",
      options: [
        "Nothing else needed",
        "Periodic or continuous chemical treatments, filters, or centralized treatment",
        "Frequent replacement only",
        "Boiling the water"
      ],
      correct: "B"
    },
    {
      id: 15222,
      question: "What are two types of dental water treatment systems?",
      options: [
        "Hot and cold",
        "Treatment cartridges that disinfect and filter devices that remove particles",
        "Automatic and manual",
        "Internal and external"
      ],
      correct: "B"
    },
    {
      id: 15223,
      question: "Where are filter devices installed?",
      options: [
        "In the water reservoir",
        "At the water source",
        "Between dental unit water line and dental instrument",
        "In the sterilizer"
      ],
      correct: "C"
    },
    {
      id: 15224,
      question: "Must filter devices be replaced?",
      options: [
        "No, they last indefinitely",
        "Yes, periodically according to manufacturer instructions",
        "Only if clogged",
        "Only annually"
      ],
      correct: "B"
    },
    {
      id: 15225,
      question: "Who regulates continuous chemical treatment products for dental water lines?",
      options: [
        "EPA",
        "OSHA",
        "FDA",
        "CDC"
      ],
      correct: "C"
    },
    {
      id: 15226,
      question: "Who registers intermittent chemical treatment products for dental water lines?",
      options: [
        "FDA",
        "CDC",
        "EPA",
        "OSHA"
      ],
      correct: "C"
    },
    {
      id: 15227,
      question: "What quality water should be used during surgical procedures?",
      options: [
        "Tap water",
        "Only sterile solutions as coolants/irrigants",
        "Distilled water",
        "Bottled water"
      ],
      correct: "B"
    },
    {
      id: 15228,
      question: "How is an oral surgical procedure defined?",
      options: [
        "Any procedure in the mouth",
        "Incision, excision, or reflection of tissue exposing normally sterile areas",
        "Routine cleaning",
        "X-ray procedures"
      ],
      correct: "B"
    },
    {
      id: 15229,
      question: "What is Principle 4 of IPC?",
      options: [
        "Take action to stay healthy",
        "Make patient care items safe",
        "Limit the spread of blood and other infectious body substances",
        "Perform hand hygiene"
      ],
      correct: "C"
    },
    {
      id: 15230,
      question: "What are examples of measures to limit spread of contamination?",
      options: [
        "Gloves only",
        "Protective barriers, high-volume evacuation, cleaning, disinfection, waste management",
        "Masks only",
        "Hand hygiene only"
      ],
      correct: "B"
    },
    {
      id: 15231,
      question: "What are housekeeping surfaces?",
      options: [
        "Clinical contact surfaces",
        "Surfaces like floors, walls, and sinks with less transmission risk",
        "Surfaces that must be sterilized",
        "Patient contact surfaces"
      ],
      correct: "B"
    },
    {
      id: 15232,
      question: "How should housekeeping surfaces be cleaned?",
      options: [
        "High-level disinfection",
        "Sterilization",
        "Soap and water; disinfected if visibly contaminated with blood or OPIM",
        "Alcohol only"
      ],
      correct: "C"
    },
    {
      id: 15233,
      question: "What are clinical contact surfaces?",
      options: [
        "Floors and walls",
        "Surfaces contaminated from spray/droplets or touched with gloved hands",
        "Surfaces outside the operatory",
        "Surfaces in waiting room"
      ],
      correct: "B"
    },
    {
      id: 15234,
      question: "How should clinical contact surfaces be managed?",
      options: [
        "Left as is",
        "Cleaned and disinfected or barrier-protected",
        "Wiped with water",
        "Vacuumed only"
      ],
      correct: "B"
    },
    {
      id: 15235,
      question: "What are examples of clinical contact surfaces?",
      options: [
        "Floors and ceilings",
        "Dental chair touch areas, dental unit, light handles, countertops",
        "Waiting room furniture",
        "Office doors"
      ],
      correct: "B"
    },
    {
      id: 15236,
      question: "Should barriers be changed between patients?",
      options: [
        "No, once per day is sufficient",
        "Only if visibly soiled",
        "Yes, always change barriers between patients",
        "Only once per week"
      ],
      correct: "C"
    },
    {
      id: 15237,
      question: "What level of disinfectant should be used for surfaces without barriers?",
      options: [
        "High-level disinfectant",
        "Sterilization",
        "EPA-registered hospital disinfectant (low or intermediate level)",
        "Soap and water only"
      ],
      correct: "C"
    },
    {
      id: 15238,
      question: "When should intermediate-level disinfectant be used?",
      options: [
        "For all surfaces",
        "For surfaces with visible blood or OPIM",
        "Never",
        "Only in surgical suites"
      ],
      correct: "B"
    },
    {
      id: 15239,
      question: "What PPE should be worn during environmental cleaning?",
      options: [
        "Gloves only",
        "Mask only",
        "Gloves and other PPE to prevent exposure",
        "No PPE needed"
      ],
      correct: "C"
    },
    {
      id: 15240,
      question: "What type of gloves offer more protection when using chemical disinfectants?",
      options: [
        "Latex examination gloves",
        "Nitrile examination gloves",
        "Chemical- and puncture-resistant utility gloves",
        "Vinyl examination gloves"
      ],
      correct: "C"
    },
    {
      id: 15241,
      question: "What is an occupational exposure?",
      options: [
        "Any time at work",
        "Percutaneous injury or mucous membrane contact with potentially infectious materials",
        "Being near a patient",
        "Touching any surface"
      ],
      correct: "B"
    },
    {
      id: 15242,
      question: "Are all exposures of equal risk?",
      options: [
        "Yes, all are the same",
        "No, risk varies with amount of blood, viral titer, depth of injury, type of exposure, and immune status",
        "Yes, if same pathogen involved",
        "No, only needlesticks are risky"
      ],
      correct: "B"
    },
    {
      id: 15243,
      question: "What is the goal when an exposure occurs?",
      options: [
        "To document it thoroughly",
        "To contain the injury as soon as possible to reduce transmission risk",
        "To notify the patient",
        "To complete the procedure"
      ],
      correct: "B"
    },
    {
      id: 15244,
      question: "Who should provide postexposure management?",
      options: [
        "Any physician",
        "The office manager",
        "A qualified healthcare provider trained in infectious diseases",
        "The dentist"
      ],
      correct: "C"
    },
    {
      id: 15245,
      question: "What is Step 1 of postexposure management?",
      options: [
        "Report the incident",
        "Apply immediate first aid - wash or flush the area",
        "Contact the patient",
        "Complete paperwork"
      ],
      correct: "B"
    },
    {
      id: 15246,
      question: "Should the wound be \"milked\" to encourage bleeding?",
      options: [
        "Yes, to remove contaminants",
        "No, this would further irritate the area",
        "Only for deep wounds",
        "Only for needlesticks"
      ],
      correct: "B"
    },
    {
      id: 15247,
      question: "Should caustic agents like bleach be used on exposure wounds?",
      options: [
        "Yes, to kill viruses",
        "No, they further irritate the area",
        "Only diluted bleach",
        "Only for HBV exposure"
      ],
      correct: "B"
    },
    {
      id: 15248,
      question: "What is Step 2 of postexposure management?",
      options: [
        "Seek medical care",
        "Report incident to designated individual",
        "Clean the wound again",
        "Notify the patient\'s physician"
      ],
      correct: "B"
    },
    {
      id: 15249,
      question: "Should reporting delay treatment?",
      options: [
        "Yes, complete all paperwork first",
        "No, completion of report should not delay treatment",
        "Only if it\'s after hours",
        "Only for minor exposures"
      ],
      correct: "B"
    },
    {
      id: 15250,
      question: "When should postexposure management begin?",
      options: [
        "Within 24 hours",
        "Within the first 1 to 2 hours",
        "The next day",
        "Within one week"
      ],
      correct: "B"
    },
    {
      id: 15251,
      question: "How effective can prompt postexposure management be in reducing HIV infection risk?",
      options: [
        "50% reduction",
        "60% reduction",
        "Approximately 80% reduction",
        "100% prevention"
      ],
      correct: "C"
    },
    {
      id: 15252,
      question: "What might postexposure prophylaxis for HIV involve?",
      options: [
        "One antiretroviral drug",
        "Antibiotics",
        "A 4-week regimen of 2 or more antiretroviral drugs",
        "No medication needed"
      ],
      correct: "C"
    },
    {
      id: 15253,
      question: "What is the average risk of HBV infection after exposure in unvaccinated persons?",
      options: [
        "1% to 5%",
        "6% to 30%",
        "50% to 60%",
        "70% to 80%"
      ],
      correct: "B"
    },
    {
      id: 15254,
      question: "What is the best protection against HBV?",
      options: [
        "Postexposure prophylaxis",
        "Vaccination",
        "Antibiotics",
        "Immune globulin"
      ],
      correct: "B"
    },
    {
      id: 15255,
      question: "What is the average risk of HCV infection after percutaneous exposure?",
      options: [
        "Less than 1%",
        "About 1.8%",
        "About 5%",
        "About 10%"
      ],
      correct: "B"
    },
    {
      id: 15256,
      question: "Is there a vaccine for HCV?",
      options: [
        "Yes, three doses",
        "Yes, one dose",
        "No",
        "Only for healthcare workers"
      ],
      correct: "C"
    },
    {
      id: 15257,
      question: "What is the average risk of HIV infection after percutaneous exposure?",
      options: [
        "1% to 2%",
        "About 0.3%",
        "5% to 10%",
        "Less than 0.1%"
      ],
      correct: "B"
    },
    {
      id: 15258,
      question: "Is it ethical to refuse treatment to a patient because they have an infectious disease?",
      options: [
        "Yes, for provider safety",
        "Yes, if the patient is high risk",
        "No, it is unethical and illegal",
        "Only for certain diseases"
      ],
      correct: "C"
    },
    {
      id: 15259,
      question: "Should patients be referred elsewhere based on infectious disease status?",
      options: [
        "Yes, always",
        "Yes, if convenient",
        "No, understanding risk and prevention is appropriate",
        "Only for HIV"
      ],
      correct: "C"
    },
    {
      id: 15260,
      question: "Who should be the designated infection prevention coordinator?",
      options: [
        "The newest employee",
        "Any volunteer",
        "Designated personnel to facilitate effective IPC implementation",
        "An outside consultant only"
      ],
      correct: "C"
    },
    {
      id: 15261,
      question: "What should the infection prevention coordinator ensure?",
      options: [
        "Only that supplies are ordered",
        "Equipment and supplies are available and maintain communication with staff",
        "Only that training is documented",
        "Only OSHA compliance"
      ],
      correct: "B"
    },
    {
      id: 15262,
      question: "What does OSAP stand for?",
      options: [
        "Occupational Safety Assurance Program",
        "Organization for Safety, Asepsis and Prevention",
        "Office Standards and Protocols",
        "Oral Safety Assessment Procedures"
      ],
      correct: "B"
    },
    {
      id: 15263,
      question: "What demonstrates a culture of safety?",
      options: [
        "Written policies only",
        "Expensive equipment",
        "Commitment to IPC by all personnel demonstrated in daily practices",
        "Annual training only"
      ],
      correct: "C"
    },
    {
      id: 15264,
      question: "How can patients be part of the safety culture?",
      options: [
        "By observing only",
        "By making informed decisions, having IPC explained, and asking questions",
        "By bringing their own PPE",
        "By reviewing OSHA regulations"
      ],
      correct: "B"
    }
  ],
  "2. Medical Emergencies in Dentistry": [
    {
      id: 15200,
      question: "What does BLS stand for?",
      options: [
        "Basic Life Support",
        "Basic Lung Service",
        "Biological Life Systems",
        "Basic Laboratory Standards"
      ],
      correct: "A"
    },
    {
      id: 15201,
      question: "What is CPR?",
      options: [
        "Cardiac Pressure Response",
        "Cardiopulmonary resuscitation",
        "Continuous Pressure Regulation",
        "Cardiac Prevention Routine"
      ],
      correct: "B"
    },
    {
      id: 15202,
      question: "What is the purpose of CPR?",
      options: [
        "To reduce blood pressure",
        "To manually preserve brain function until further medical care is available",
        "To restart the heart immediately",
        "To reduce fever"
      ],
      correct: "B"
    },
    {
      id: 15203,
      question: "What does AED stand for?",
      options: [
        "Automatic Emergency Defibrillator",
        "Advanced Emergency Device",
        "Automated External Defibrillator",
        "Automatic Electrical Detector"
      ],
      correct: "C"
    },
    {
      id: 15204,
      question: "Which organizations provide BLS/CPR guidelines?",
      options: [
        "FDA and EPA",
        "American Heart Association and International Liaison Committee on Resuscitation",
        "OSHA and CDC",
        "WHO and NIH"
      ],
      correct: "B"
    },
    {
      id: 15205,
      question: "What is the AHA chain of survival\'s first link?",
      options: [
        "Early defibrillation",
        "Advanced medical care",
        "Recognition that a medical emergency is occurring",
        "Recovery"
      ],
      correct: "C"
    },
    {
      id: 15206,
      question: "How many links are in the chain of survival?",
      options: [
        "Three",
        "Four",
        "Five",
        "Six"
      ],
      correct: "D"
    },
    {
      id: 15207,
      question: "What factors increase the likelihood of medical emergencies in dental settings?",
      options: [
        "Only increased number of medically compromised patients",
        "Only medical advances in drug therapy",
        "Increased medically compromised patients, drug advances, invasive procedures, and drug use in dental settings",
        "Only longer appointments"
      ],
      correct: "C"
    },
    {
      id: 15208,
      question: "What begins the prevention of medical emergencies?",
      options: [
        "Having emergency equipment only",
        "Comprehensive health history and risk assessment",
        "Staff training only",
        "Installing an AED"
      ],
      correct: "B"
    },
    {
      id: 15209,
      question: "What should be included in prevention strategies?",
      options: [
        "Only vital sign monitoring",
        "Only medication review",
        "Health history, vital signs, anxiety management, treatment modifications, and stress reduction",
        "Only emergency equipment availability"
      ],
      correct: "C"
    },
    {
      id: 15210,
      question: "How often should protocols for managing medical emergencies be reviewed?",
      options: [
        "Monthly",
        "Quarterly",
        "No less than annually",
        "Every 5 years"
      ],
      correct: "C"
    },
    {
      id: 15211,
      question: "What type of training is recommended annually for dental personnel?",
      options: [
        "Only CPR certification",
        "Advanced cardiac life support",
        "Refresher course in medical emergency management",
        "Pharmacy training"
      ],
      correct: "C"
    },
    {
      id: 15212,
      question: "What should practice emergency simulations prepare dental personnel for?",
      options: [
        "Only using the AED",
        "Implementation of protocols and use of emergency equipment",
        "Only calling 911",
        "Only taking vital signs"
      ],
      correct: "B"
    },
    {
      id: 15213,
      question: "What color are portable oxygen tanks in the United States?",
      options: [
        "White",
        "Blue",
        "Green",
        "Red"
      ],
      correct: "C"
    },
    {
      id: 15214,
      question: "What size oxygen cylinder do most dental settings use?",
      options: [
        "Size C",
        "Size D",
        "Size E",
        "Size F"
      ],
      correct: "C"
    },
    {
      id: 15215,
      question: "How is oxygen delivery measured?",
      options: [
        "Milliliters per hour",
        "Liters per minute",
        "Cubic feet per second",
        "Gallons per hour"
      ],
      correct: "B"
    },
    {
      id: 15216,
      question: "Approximately how many minutes of oxygen will a size E cylinder supply?",
      options: [
        "15 minutes",
        "20 minutes",
        "30 minutes",
        "45 minutes"
      ],
      correct: "C"
    },
    {
      id: 15217,
      question: "What should be determined with a pulse oximeter before administering oxygen?",
      options: [
        "Heart rate",
        "Blood pressure",
        "Oxygen saturation",
        "Temperature"
      ],
      correct: "C"
    },
    {
      id: 15218,
      question: "What does SpO2 stand for?",
      options: [
        "Special oxygen level 2",
        "Peripheral capillary oxygen saturation",
        "Systemic pressure of oxygen",
        "Standard pulse oxygen 2"
      ],
      correct: "B"
    },
    {
      id: 15219,
      question: "If a patient appears stable with an SpO2 of 90% to 94%, what may be true?",
      options: [
        "They definitely need oxygen",
        "They are in critical condition",
        "They may not require further oxygen supplementation",
        "They should be given maximum oxygen"
      ],
      correct: "C"
    },
    {
      id: 15220,
      question: "What is the target SpO2 for a patient who is acutely ill or having difficulty breathing?",
      options: [
        "85% to 90%",
        "90% to 94%",
        "94% to 98%",
        "98% to 100%"
      ],
      correct: "C"
    },
    {
      id: 15221,
      question: "What are the three ways oxygen can be delivered?",
      options: [
        "IV line, injection, or orally",
        "Nasal cannula, simple face mask, or nonrebreather mask",
        "Through skin patches only",
        "Inhalation, injection, or absorption"
      ],
      correct: "B"
    },
    {
      id: 15222,
      question: "What is the initial oxygen flow rate when using a nasal cannula?",
      options: [
        "1 L/min",
        "2 L/min",
        "4 L/min",
        "6 L/min"
      ],
      correct: "B"
    },
    {
      id: 15223,
      question: "What is the maximum oxygen flow rate via nasal cannula?",
      options: [
        "2 L/min",
        "4 L/min",
        "6 L/min",
        "10 L/min"
      ],
      correct: "C"
    },
    {
      id: 15224,
      question: "At a minimum, what should an emergency kit include?",
      options: [
        "Only epinephrine",
        "Only oxygen",
        "Epinephrine, histamine blocker, nitroglycerin, bronchodilator, oxygen, pulse oximeter, aspirin, and oral glucose",
        "Only nitroglycerin and aspirin"
      ],
      correct: "C"
    },
    {
      id: 15225,
      question: "What should the emergency kit contain regarding drug administration?",
      options: [
        "All available emergency drugs",
        "Only drugs the dentist or hygienist is trained to administer",
        "Only injectable medications",
        "Any drugs requested by patients"
      ],
      correct: "B"
    },
    {
      id: 15226,
      question: "What drug can reverse an opioid overdose?",
      options: [
        "Flumazenil",
        "Epinephrine",
        "Naloxone",
        "Nitroglycerin"
      ],
      correct: "C"
    },
    {
      id: 15227,
      question: "What drug reverses the effects of benzodiazepines?",
      options: [
        "Naloxone",
        "Flumazenil",
        "Diphenhydramine",
        "Glucagon"
      ],
      correct: "B"
    },
    {
      id: 15228,
      question: "Why is the use of ammonia inhalants for unconscious patients no longer recommended?",
      options: [
        "They are too expensive",
        "They may be harmful and produce complications",
        "They are not effective for any condition",
        "They are no longer manufactured"
      ],
      correct: "B"
    },
    {
      id: 15229,
      question: "What may ammonia inhalants cause in patients with impaired gag reflex?",
      options: [
        "Improved breathing",
        "Faster recovery",
        "Aspiration from coughing, nausea, and vomiting",
        "Immediate consciousness"
      ],
      correct: "C"
    },
    {
      id: 15230,
      question: "What additional items might be included in an emergency kit?",
      options: [
        "Only gauze",
        "Pocket mask, syringes, sugar packets, blanket, thermometer, emesis basin, and Magill forceps",
        "Only bandages",
        "Only scissors"
      ],
      correct: "B"
    },
    {
      id: 15231,
      question: "How often should the dental emergency kit be monitored and updated?",
      options: [
        "Annually",
        "Monthly",
        "At least quarterly and after every emergency",
        "Only after emergencies"
      ],
      correct: "C"
    },
    {
      id: 15232,
      question: "Who should be designated to monitor emergency kit contents?",
      options: [
        "Any staff member when they have time",
        "The receptionist only",
        "An individual in the dental setting",
        "An outside vendor"
      ],
      correct: "C"
    },
    {
      id: 15233,
      question: "What should dental hygienists have in their treatment area?",
      options: [
        "Only gloves",
        "Their own resuscitation masks",
        "Only gauze",
        "Only suction equipment"
      ],
      correct: "B"
    },
    {
      id: 15234,
      question: "What forms should be available to record emergency information?",
      options: [
        "Only consent forms",
        "Emergency medical report forms",
        "Only insurance forms",
        "Only health history forms"
      ],
      correct: "B"
    },
    {
      id: 15235,
      question: "What information should emergency medical report forms record?",
      options: [
        "Only patient name",
        "Time of onset, treatment or drugs administered, and vital signs",
        "Only vital signs",
        "Only time of onset"
      ],
      correct: "B"
    },
    {
      id: 15236,
      question: "What should be done with a copy of the emergency report?",
      options: [
        "Destroyed after 24 hours",
        "Only kept in office files",
        "Given to EMS personnel and accompany patient to emergency department",
        "Sent to insurance company only"
      ],
      correct: "C"
    },
    {
      id: 15237,
      question: "What should be readily available if an emergency arises?",
      options: [
        "Only phone numbers",
        "Emergency assistance numbers, emergency drug kit, oxygen, and AED",
        "Only emergency drugs",
        "Only oxygen"
      ],
      correct: "B"
    },
    {
      id: 15238,
      question: "What telephone numbers should be visibly posted?",
      options: [
        "Only 911",
        "Staff home numbers",
        "Local police, fire, poison control center, and facility address with room number",
        "Only poison control"
      ],
      correct: "C"
    },
    {
      id: 15239,
      question: "How often should posted emergency numbers be updated?",
      options: [
        "Monthly",
        "Quarterly",
        "Annually",
        "Every 5 years"
      ],
      correct: "C"
    },
    {
      id: 15240,
      question: "What should every dental setting have regarding medical emergencies?",
      options: [
        "Only emergency equipment",
        "A medical emergency plan",
        "Only trained staff",
        "Only emergency phone numbers"
      ],
      correct: "B"
    },
    {
      id: 15241,
      question: "What should each oral care team member have in an emergency?",
      options: [
        "Their own equipment",
        "A specific role to play",
        "A separate phone",
        "Their own emergency kit"
      ],
      correct: "B"
    },
    {
      id: 15242,
      question: "How should roles in an emergency be maintained?",
      options: [
        "Never reviewed",
        "Periodically reviewed and practiced",
        "Only written down",
        "Only discussed once"
      ],
      correct: "B"
    },
    {
      id: 15243,
      question: "What should be provided to all new employees regarding emergencies?",
      options: [
        "Only a tour",
        "Protocols for managing a medical emergency",
        "Only phone numbers",
        "Only equipment location"
      ],
      correct: "B"
    },
    {
      id: 15244,
      question: "What is the ASA physical status classification used for?",
      options: [
        "To determine salary",
        "To determine a patient\'s physical status as a medical assessment framework",
        "To schedule appointments",
        "To determine treatment costs"
      ],
      correct: "B"
    },
    {
      id: 15245,
      question: "How many ASA categories are there?",
      options: [
        "Three",
        "Four",
        "Five",
        "Six"
      ],
      correct: "D"
    },
    {
      id: 15246,
      question: "What does ASA I represent?",
      options: [
        "Severe systemic disease",
        "Normal health - \"green light\" for elective dental treatment",
        "Mild systemic disease",
        "Near death"
      ],
      correct: "B"
    },
    {
      id: 15247,
      question: "What do ASA II or III represent?",
      options: [
        "Red light",
        "Green light",
        "Yellow light requiring caution",
        "No treatment allowed"
      ],
      correct: "C"
    },
    {
      id: 15248,
      question: "Which ASA categories will dental hygienists commonly see?",
      options: [
        "Only ASA I",
        "ASA I, II, and III",
        "Only ASA IV and V",
        "Only ASA VI"
      ],
      correct: "B"
    },
    {
      id: 15249,
      question: "What does ASA IV represent?",
      options: [
        "Normal health",
        "Mild disease",
        "Severe systemic disease constantly threatening life - \"red light\"",
        "Brain dead"
      ],
      correct: "C"
    },
    {
      id: 15250,
      question: "When should ASA IV patients receive dental treatment?",
      options: [
        "Anytime",
        "Only conservative emergency treatments until condition stabilizes",
        "Never",
        "Only in hospitals"
      ],
      correct: "B"
    },
    {
      id: 15251,
      question: "What does ASA VI indicate?",
      options: [
        "Normal health",
        "Mild disease",
        "Declared brain dead; organs being removed for donor purposes",
        "Severe but stable disease"
      ],
      correct: "C"
    },
    {
      id: 15252,
      question: "Why is monitoring vital signs important?",
      options: [
        "Only for documentation",
        "To assess overall health and compare normal with emergency readings",
        "Only required by law",
        "Only for insurance purposes"
      ],
      correct: "B"
    },
    {
      id: 15253,
      question: "What may vital signs outside normal ranges indicate?",
      options: [
        "Nothing significant",
        "Underlying medical issues",
        "Only measurement error",
        "Only patient anxiety"
      ],
      correct: "B"
    },
    {
      id: 15254,
      question: "When may a physician consultation be needed?",
      options: [
        "Never",
        "To determine if modifications or delay in treatment is necessary",
        "Only for surgical procedures",
        "Only for new patients"
      ],
      correct: "B"
    },
    {
      id: 15255,
      question: "What can heightened anxiety and fear of dental care lead to?",
      options: [
        "Only mild discomfort",
        "Hyperventilation, syncope, or acute exacerbation of conditions",
        "Improved cooperation",
        "Faster treatment"
      ],
      correct: "B"
    },
    {
      id: 15256,
      question: "What is one goal of patient assessment regarding psychology?",
      options: [
        "To judge the patient",
        "To determine if patient can tolerate stress associated with planned care",
        "To determine payment method",
        "To schedule future appointments"
      ],
      correct: "B"
    },
    {
      id: 15257,
      question: "How can anxiety be recognized?",
      options: [
        "Only through complex testing",
        "By asking about fear, anxiety, and past traumatic experiences",
        "It cannot be recognized",
        "Only through vital signs"
      ],
      correct: "B"
    },
    {
      id: 15258,
      question: "Why might patients underestimate dental anxiety?",
      options: [
        "They don\'t want to acknowledge it",
        "They enjoy dental treatment",
        "They have no anxiety",
        "They want more treatment"
      ],
      correct: "A"
    },
    {
      id: 15259,
      question: "What are signs of severely anxious individuals?",
      options: [
        "Calm demeanor",
        "Slow heart rate",
        "Increased blood pressure, trembling, excessive perspiration, and dilated pupils",
        "Normal appearance"
      ],
      correct: "C"
    },
    {
      id: 15260,
      question: "What are stress-reduction protocols?",
      options: [
        "Only medication",
        "Steps taken to reduce dental anxiety and fear",
        "Only breathing exercises",
        "Only appointment scheduling"
      ],
      correct: "B"
    },
    {
      id: 15261,
      question: "When should stress reduction start?",
      options: [
        "Only during the appointment",
        "Only after treatment",
        "Before appointment, continue throughout, and into postoperative period if necessary",
        "Only during emergencies"
      ],
      correct: "C"
    },
    {
      id: 15262,
      question: "What general stress reduction strategies are recommended?",
      options: [
        "Only pharmacologic",
        "Building rapport, maintaining communication, minimizing wait time, and short morning appointments",
        "Only longer appointments",
        "Only afternoon appointments"
      ],
      correct: "B"
    },
    {
      id: 15263,
      question: "What pharmacologic stress reduction options may be used?",
      options: [
        "Only pain medications",
        "Only local anesthesia",
        "Preappointment sedation, nitrous oxide, profound local anesthesia, adequate pain control",
        "Only antibiotics"
      ],
      correct: "C"
    },
    {
      id: 15264,
      question: "What management techniques can help dental anxiety?",
      options: [
        "Only medication",
        "Acupuncture, biofeedback, cognitive therapy, distraction, guided imagery, relaxation techniques",
        "Only sedation",
        "Only restraints"
      ],
      correct: "B"
    },
    {
      id: 15265,
      question: "What does unresponsiveness mean?",
      options: [
        "Patient is sleeping",
        "Patient does not respond to sensory stimulation",
        "Patient is resting",
        "Patient is meditating"
      ],
      correct: "B"
    },
    {
      id: 15266,
      question: "How is unresponsiveness tested?",
      options: [
        "Only checking pulse",
        "Gently shaking and shouting \"Are you all right?\"",
        "Only checking breathing",
        "Waiting to see if patient wakes up"
      ],
      correct: "B"
    },
    {
      id: 15267,
      question: "If a patient is unresponsive, not breathing, or only gasping, what should be done?",
      options: [
        "Wait and observe",
        "Give them water",
        "Immediately activate BLS",
        "Leave them alone"
      ],
      correct: "C"
    },
    {
      id: 15268,
      question: "What is the first step when unresponsiveness is recognized?",
      options: [
        "Call the patient\'s family",
        "Terminate dental hygiene procedures and activate EMS",
        "Continue treatment",
        "Give medication"
      ],
      correct: "B"
    },
    {
      id: 15269,
      question: "What is 911?",
      options: [
        "An emergency number in all countries",
        "The standard emergency number in the United States and Canada",
        "A non-emergency number",
        "Only for fire emergencies"
      ],
      correct: "B"
    },
    {
      id: 15270,
      question: "What position should an unconscious person be placed in?",
      options: [
        "Sitting upright",
        "On their side",
        "Supine (horizontal)",
        "Trendelenburg"
      ],
      correct: "C"
    },
    {
      id: 15271,
      question: "Why is the supine position used for unconscious patients?",
      options: [
        "It\'s most comfortable",
        "Brain is at same level as body to help deliver oxygenated blood",
        "It prevents vomiting",
        "It\'s easier for the provider"
      ],
      correct: "B"
    },
    {
      id: 15272,
      question: "What should be removed from the dental chair headrest when a patient loses consciousness?",
      options: [
        "Nothing",
        "The chair itself",
        "Any extra head supports like pillows",
        "The armrests"
      ],
      correct: "C"
    },
    {
      id: 15273,
      question: "What should be done after placing an unconscious patient in supine position?",
      options: [
        "Wait for them to wake up",
        "Give them water",
        "Begin life support by delivering high-quality CPR",
        "Cover them with a blanket"
      ],
      correct: "C"
    },
    {
      id: 15274,
      question: "What can assisting personnel obtain during an emergency?",
      options: [
        "Coffee",
        "Patient records only",
        "AED, oxygen, bag-valve-mask, aspirin from emergency kit",
        "Only paperwork"
      ],
      correct: "C"
    },
    {
      id: 15275,
      question: "Early defibrillation can restore what?",
      options: [
        "Blood pressure only",
        "A normal heart rhythm",
        "Consciousness only",
        "Breathing only"
      ],
      correct: "B"
    },
    {
      id: 15276,
      question: "Each minute of delayed defibrillation reduces survival chance by approximately what percentage?",
      options: [
        "5%",
        "10%",
        "15%",
        "20%"
      ],
      correct: "B"
    },
    {
      id: 15277,
      question: "What is the final link in the chain of survival?",
      options: [
        "CPR",
        "Defibrillation",
        "Advanced life support",
        "Recovery"
      ],
      correct: "D"
    },
    {
      id: 15278,
      question: "In all medical emergencies, what should be done first?",
      options: [
        "Give medication",
        "Terminate dental treatment, activate facility emergency procedures, monitor vital signs and SpO2",
        "Continue treatment",
        "Call patient\'s physician"
      ],
      correct: "B"
    },
    {
      id: 15279,
      question: "If a patient becomes unconscious or unresponsive in any emergency, what should be initiated?",
      options: [
        "Only oxygen administration",
        "Patient transport",
        "BLS sequence",
        "Medication administration"
      ],
      correct: "C"
    },
    {
      id: 15280,
      question: "What is adrenal crisis?",
      options: [
        "High cortisol levels",
        "Cortisol deficiency",
        "High adrenaline",
        "Low blood sugar"
      ],
      correct: "B"
    },
    {
      id: 15281,
      question: "What are signs of adrenal crisis?",
      options: [
        "High blood pressure and fast pulse",
        "Confusion, weakness, respiratory depression, low blood pressure, weak rapid pulse",
        "High energy",
        "Increased appetite"
      ],
      correct: "B"
    },
    {
      id: 15282,
      question: "How should a responsive patient with adrenal crisis be positioned?",
      options: [
        "Upright",
        "On their side",
        "Supine with feet slightly elevated",
        "Trendelenburg"
      ],
      correct: "C"
    },
    {
      id: 15283,
      question: "What should a responsive patient with adrenal crisis be asked to do?",
      options: [
        "Drink water",
        "Self-administer a stress dose of their own corticosteroid medication",
        "Take aspirin",
        "Use their inhaler"
      ],
      correct: "B"
    },
    {
      id: 15284,
      question: "What indicates partial (mild) airway obstruction?",
      options: [
        "Silent cough",
        "Effective coughing with adequate oxygen exchange",
        "Unable to speak",
        "Complete blockage"
      ],
      correct: "B"
    },
    {
      id: 15285,
      question: "What should be done for partial airway obstruction if air exchange is adequate?",
      options: [
        "Immediate abdominal thrusts",
        "Encourage patient to continue coughing",
        "Begin CPR",
        "Give oxygen"
      ],
      correct: "B"
    },
    {
      id: 15286,
      question: "What indicates complete (severe) airway obstruction?",
      options: [
        "Effective coughing",
        "Able to speak",
        "Silent cough, unable to speak, cyanosis",
        "Loud wheezing"
      ],
      correct: "C"
    },
    {
      id: 15287,
      question: "What should be done for complete airway obstruction?",
      options: [
        "Give water",
        "Encourage coughing",
        "Begin abdominal thrusts (Heimlich maneuver) until object is dislodged",
        "Wait for EMS"
      ],
      correct: "C"
    },
    {
      id: 15288,
      question: "What should be used instead of abdominal thrusts for pregnant or obese patients with airway obstruction?",
      options: [
        "Back blows",
        "Chest compressions",
        "Finger sweeps",
        "Waiting"
      ],
      correct: "B"
    },
    {
      id: 15289,
      question: "What is angina pectoris?",
      options: [
        "Lung pain",
        "Chest pain due to inadequate blood and oxygen supply to heart muscle",
        "Stomach pain",
        "Headache"
      ],
      correct: "B"
    },
    {
      id: 15290,
      question: "How long does angina pain typically last?",
      options: [
        "Less than 5 minutes",
        "Less than 15 minutes",
        "30 minutes",
        "Over an hour"
      ],
      correct: "B"
    },
    {
      id: 15291,
      question: "What position should a patient with stable angina be placed in?",
      options: [
        "Supine",
        "Comfortable position, usually upright",
        "On their side",
        "Trendelenburg"
      ],
      correct: "B"
    },
    {
      id: 15292,
      question: "What medication should be administered for angina?",
      options: [
        "Aspirin",
        "Epinephrine",
        "Nitroglycerin 0.4 mg sublingually (preferably self-administered)",
        "Glucagon"
      ],
      correct: "C"
    },
    {
      id: 15293,
      question: "How often can nitroglycerin be given for angina?",
      options: [
        "Every 2 minutes",
        "Every 5 minutes, maximum of three doses",
        "Every 10 minutes",
        "Only once"
      ],
      correct: "B"
    },
    {
      id: 15294,
      question: "If angina pain is not relieved by nitroglycerin, what should be done?",
      options: [
        "Give more nitroglycerin",
        "Wait longer",
        "Activate EMS and treat as myocardial infarction",
        "Send patient home"
      ],
      correct: "C"
    },
    {
      id: 15295,
      question: "What causes an asthma attack?",
      options: [
        "High blood pressure",
        "Narrowing of bronchial airways due to bronchospasm, excessive mucus, or inflammation",
        "Low blood sugar",
        "Dehydration"
      ],
      correct: "B"
    },
    {
      id: 15296,
      question: "What are signs of an asthma attack?",
      options: [
        "High blood pressure",
        "Nonproductive cough, wheezing, increased respiratory efforts, shortness of breath",
        "Fever",
        "Rash"
      ],
      correct: "B"
    },
    {
      id: 15297,
      question: "What position facilitates breathing for asthma patients?",
      options: [
        "Supine",
        "Upright is usually best",
        "On their side",
        "Head down"
      ],
      correct: "B"
    },
    {
      id: 15298,
      question: "What medication should be administered for an asthma attack?",
      options: [
        "Nitroglycerin",
        "Aspirin",
        "Bronchodilator (preferably self-administered)",
        "Epinephrine immediately"
      ],
      correct: "C"
    },
    {
      id: 15299,
      question: "If an asthma patient becomes unresponsive, what should be administered?",
      options: [
        "Nitroglycerin",
        "Aspirin",
        "Bronchodilator",
        "Epinephrine 0.3 mg of 1:1000"
      ],
      correct: "D"
    },
    {
      id: 15300,
      question: "What is cardiac arrest?",
      options: [
        "Slow heart rate",
        "Irregular heartbeat",
        "Sudden cessation of heart function",
        "High blood pressure"
      ],
      correct: "C"
    },
    {
      id: 15301,
      question: "What are signs of cardiac arrest?",
      options: [
        "Fast pulse",
        "Absence of pulse, absence of respirations, unconsciousness",
        "High blood pressure",
        "Fever"
      ],
      correct: "B"
    },
    {
      id: 15302,
      question: "What is the first step in managing cardiac arrest?",
      options: [
        "Give medication",
        "Check blood pressure",
        "Place patient in supine position and activate EMS",
        "Give oxygen only"
      ],
      correct: "C"
    },
    {
      id: 15303,
      question: "What should be initiated immediately for cardiac arrest?",
      options: [
        "Only oxygen",
        "Only medication",
        "BLS",
        "Patient transport"
      ],
      correct: "C"
    },
    {
      id: 15304,
      question: "What is a cerebrovascular accident (CVA)?",
      options: [
        "Heart attack",
        "Seizure",
        "Occlusion or hemorrhage of cerebral blood vessel resulting in ischemia (stroke)",
        "Allergic reaction"
      ],
      correct: "C"
    },
    {
      id: 15305,
      question: "What are signs of a stroke?",
      options: [
        "Chest pain",
        "Sudden weakness of one side, severe headache, difficulty speaking, vision changes",
        "Abdominal pain",
        "Rash"
      ],
      correct: "B"
    },
    {
      id: 15306,
      question: "What position should a stroke patient be placed in?",
      options: [
        "Supine",
        "Semisupine",
        "Upright",
        "On affected side"
      ],
      correct: "B"
    },
    {
      id: 15307,
      question: "What should be done immediately when a stroke is suspected?",
      options: [
        "Wait and observe",
        "Give aspirin",
        "Activate EMS",
        "Give food"
      ],
      correct: "C"
    },
    {
      id: 15308,
      question: "What should be avoided doing to an injured eye?",
      options: [
        "Looking at it",
        "Touching, rubbing, or applying medicine or pressure",
        "Calling for help",
        "Covering the other eye"
      ],
      correct: "B"
    },
    {
      id: 15309,
      question: "For an eye puncture or cut, what should be done?",
      options: [
        "Rinse with water",
        "Remove the object",
        "Activate EMS and place a shield over the eye",
        "Apply pressure"
      ],
      correct: "C"
    },
    {
      id: 15310,
      question: "How should a chemical burn to the eye be treated?",
      options: [
        "Do nothing",
        "Apply ointment",
        "Immediately flush the eye mesially to distally with clean water or saline for 15 minutes, then activate EMS",
        "Cover with bandage"
      ],
      correct: "C"
    },
    {
      id: 15311,
      question: "How should arterial hemorrhage be controlled?",
      options: [
        "Ice only",
        "Elevation only",
        "Apply compression over hemorrhage, usually with gauze",
        "Wait for it to stop"
      ],
      correct: "C"
    },
    {
      id: 15312,
      question: "What color is arterial blood?",
      options: [
        "Dark red and oozes",
        "Red and spurts",
        "Brown",
        "Pink"
      ],
      correct: "B"
    },
    {
      id: 15313,
      question: "For a dental extraction site bleeding, what should be done?",
      options: [
        "Do nothing",
        "Rinse with water",
        "Pack the area with gauze and have patient bite down",
        "Give antibiotics"
      ],
      correct: "C"
    },
    {
      id: 15314,
      question: "What defines a hypertensive emergency?",
      options: [
        "Any high blood pressure",
        "Systolic >140 mm Hg",
        "Severe blood pressure elevation with evidence of target organ damage",
        "Diastolic >100 mm Hg"
      ],
      correct: "C"
    },
    {
      id: 15315,
      question: "What blood pressure readings indicate hypertensive crisis?",
      options: [
        "Systolic >140 and/or diastolic >90",
        "Systolic >160 and/or diastolic >100",
        "Systolic >180 and/or diastolic >120",
        "Systolic >200 and/or diastolic >140"
      ],
      correct: "C"
    },
    {
      id: 15316,
      question: "What should be done for hypertensive urgency?",
      options: [
        "Give medication in office",
        "Advise patient to seek advanced medical assessment immediately",
        "Continue with dental treatment",
        "Ignore it"
      ],
      correct: "B"
    },
    {
      id: 15317,
      question: "What causes hyperventilation?",
      options: [
        "Low oxygen",
        "Respiratory alkalosis from excessive loss of carbon dioxide",
        "High carbon dioxide",
        "Infection"
      ],
      correct: "B"
    },
    {
      id: 15318,
      question: "What are signs of hyperventilation?",
      options: [
        "Slow breathing",
        "Rapid or shallow respirations, lightheadedness, tingling in extremities",
        "Fever",
        "Rash"
      ],
      correct: "B"
    },
    {
      id: 15319,
      question: "What position should a hyperventilating patient be placed in?",
      options: [
        "Supine",
        "On their side",
        "Upright",
        "Trendelenburg"
      ],
      correct: "C"
    },
    {
      id: 15320,
      question: "Should oxygen be administered for hyperventilation?",
      options: [
        "Yes, always",
        "Yes, at maximum flow",
        "No",
        "Only if SpO2 is low"
      ],
      correct: "C"
    },
    {
      id: 15321,
      question: "How should a hyperventilating patient breathe?",
      options: [
        "Rapidly",
        "Hold their breath",
        "Slowly and normally, through pursed lips or into cupped hands",
        "Only through nose"
      ],
      correct: "C"
    },
    {
      id: 15322,
      question: "What is a myocardial infarction?",
      options: [
        "Lung collapse",
        "Stroke",
        "Necrosis of myocardium due to total or partial occlusion of an artery (heart attack)",
        "Seizure"
      ],
      correct: "C"
    },
    {
      id: 15323,
      question: "How is myocardial infarction pain different from angina?",
      options: [
        "It is milder",
        "It is usually more severe and not relieved by rest and nitroglycerin",
        "It only lasts seconds",
        "It only occurs at night"
      ],
      correct: "B"
    },
    {
      id: 15324,
      question: "What position should a myocardial infarction patient be placed in?",
      options: [
        "Supine",
        "Comfortable position, usually semisupine or upright",
        "Flat on back",
        "On left side"
      ],
      correct: "B"
    },
    {
      id: 15325,
      question: "What medication should a myocardial infarction patient chew?",
      options: [
        "Nitroglycerin",
        "Diphenhydramine",
        "162 to 325 mg of chewable, nonenteric-coated aspirin",
        "Glucagon"
      ],
      correct: "C"
    },
    {
      id: 15326,
      question: "What causes pulmonary edema (acute)?",
      options: [
        "Dehydration",
        "Impairment of heart muscle from left ventricular failure, resulting in fluid in lungs",
        "Infection",
        "Allergic reaction"
      ],
      correct: "B"
    },
    {
      id: 15327,
      question: "What are signs of acute pulmonary edema?",
      options: [
        "Rash",
        "Shortness of breath, difficulty breathing, pink frothy sputum, swelling of lower extremities",
        "Fever",
        "Headache"
      ],
      correct: "B"
    },
    {
      id: 15328,
      question: "What position should a patient with pulmonary edema be placed in?",
      options: [
        "Supine",
        "Upright",
        "On their side",
        "Trendelenburg"
      ],
      correct: "B"
    },
    {
      id: 15329,
      question: "How much nitroglycerin should be administered for pulmonary edema?",
      options: [
        "0.4 mg once",
        "0.8 to 1.2 mg (2 to 3 tablets or sprays) every 5 to 10 minutes",
        "2 mg once",
        "No nitroglycerin"
      ],
      correct: "B"
    },
    {
      id: 15330,
      question: "What is psychogenic shock?",
      options: [
        "Electric shock",
        "Cerebral hypoxia (treated same as syncope)",
        "Anaphylaxis",
        "Hemorrhagic shock"
      ],
      correct: "B"
    },
    {
      id: 15331,
      question: "What are signs of shock?",
      options: [
        "High blood pressure",
        "Hypotension, pale clammy skin, rapid weak pulse, rapid shallow respirations",
        "Fever",
        "Rash"
      ],
      correct: "B"
    },
    {
      id: 15332,
      question: "How should a patient in shock be positioned?",
      options: [
        "Upright",
        "On their side",
        "Supine with elevated feet",
        "Sitting"
      ],
      correct: "C"
    },
    {
      id: 15333,
      question: "What is syncope?",
      options: [
        "Seizure",
        "Sudden transient loss of consciousness (fainting)",
        "Heart attack",
        "Stroke"
      ],
      correct: "B"
    },
    {
      id: 15334,
      question: "What are early signs of syncope?",
      options: [
        "High blood pressure",
        "Pallor, nausea, fast pulse (early), perspiration, pupil dilation",
        "Fever",
        "Rash"
      ],
      correct: "B"
    },
    {
      id: 15335,
      question: "How should a syncopal patient be positioned?",
      options: [
        "Upright",
        "Supine with legs slightly elevated; pregnant patient rolled on left side",
        "On their back flat",
        "Sitting"
      ],
      correct: "B"
    },
    {
      id: 15336,
      question: "If hypoglycemia is suspected during postsyncopal recovery, what should be administered?",
      options: [
        "Insulin",
        "Epinephrine",
        "Oral glucose",
        "Nitroglycerin"
      ],
      correct: "C"
    },
    {
      id: 15337,
      question: "What is a generalized tonic-clonic (grand mal) seizure?",
      options: [
        "Brief staring spell",
        "Generalized electronic abnormality in brain with loss of consciousness",
        "Localized muscle twitch",
        "Headache"
      ],
      correct: "B"
    },
    {
      id: 15338,
      question: "What might precede a tonic-clonic seizure?",
      options: [
        "Nothing",
        "Aura (change in taste, smell, or sight)",
        "Fever",
        "Rash"
      ],
      correct: "B"
    },
    {
      id: 15339,
      question: "What should be done during a tonic-clonic seizure?",
      options: [
        "Restrain the patient",
        "Put something in their mouth",
        "Place patient in supine position, protect from injury, clear area of sharp objects",
        "Give water"
      ],
      correct: "C"
    },
    {
      id: 15340,
      question: "Should you restrain a person having a seizure?",
      options: [
        "Yes, always",
        "Yes, to protect them",
        "No, do not attempt to restrain",
        "Only if violent"
      ],
      correct: "C"
    },
    {
      id: 15341,
      question: "If a seizure is unresolved (status epilepticus), what should be done?",
      options: [
        "Wait longer",
        "Give oral medication",
        "Activate EMS",
        "Continue observing only"
      ],
      correct: "C"
    },
    {
      id: 15342,
      question: "What is a nonconvulsive (petit mal) seizure?",
      options: [
        "Loss of consciousness with convulsions",
        "Generalized electronic abnormality without loss of consciousness",
        "Stroke",
        "Fainting"
      ],
      correct: "B"
    },
    {
      id: 15343,
      question: "How long does a petit mal seizure typically last?",
      options: [
        "Less than 1 second",
        "Several to 90 seconds",
        "5 minutes",
        "Over 10 minutes"
      ],
      correct: "B"
    },
    {
      id: 15344,
      question: "What is hyperglycemia (ketoacidosis)?",
      options: [
        "Low blood sugar",
        "Excess glucose and insufficient insulin levels",
        "High insulin",
        "Low cortisol"
      ],
      correct: "B"
    },
    {
      id: 15345,
      question: "What are signs of hyperglycemia?",
      options: [
        "Hunger, perspiration, confusion",
        "Excessive thirst, urination, hunger, dry flushed skin, fruity breath smell",
        "High blood pressure",
        "Rash"
      ],
      correct: "B"
    },
    {
      id: 15346,
      question: "For a responsive hyperglycemic patient, what should be retrieved?",
      options: [
        "Their food",
        "Oral glucose",
        "The patient\'s insulin",
        "Epinephrine"
      ],
      correct: "C"
    },
    {
      id: 15347,
      question: "Who should administer insulin to a hyperglycemic patient if able?",
      options: [
        "The dental hygienist",
        "The dentist",
        "The patient should self-administer",
        "EMS only"
      ],
      correct: "C"
    },
    {
      id: 15348,
      question: "What is hypoglycemia?",
      options: [
        "High blood sugar",
        "Insufficient glucose levels (insulin shock)",
        "High insulin production",
        "Low cortisol"
      ],
      correct: "B"
    },
    {
      id: 15349,
      question: "What are signs of hypoglycemia?",
      options: [
        "Dry skin, slow pulse",
        "Mood changes, hunger, perspiration, confusion, irritation, weakness",
        "High blood pressure",
        "Rash"
      ],
      correct: "B"
    },
    {
      id: 15350,
      question: "For a responsive hypoglycemic patient, what should be given?",
      options: [
        "Insulin",
        "Water only",
        "Concentrated form of oral sugar",
        "Protein"
      ],
      correct: "C"
    },
    {
      id: 15351,
      question: "What are examples of concentrated oral sugar?",
      options: [
        "Diet soda, water",
        "Sugar packet, cake icing, concentrated orange juice, sugar-containing soda",
        "Crackers, bread",
        "Vegetables"
      ],
      correct: "B"
    },
    {
      id: 15352,
      question: "If hypoglycemia symptoms don\'t resolve within 10 minutes, what should be done?",
      options: [
        "Give more sugar",
        "Wait longer",
        "Emergency services should be activated",
        "Send patient home"
      ],
      correct: "C"
    },
    {
      id: 15353,
      question: "For an unresponsive hypoglycemic patient, what medication should be given if available and trained?",
      options: [
        "Insulin",
        "Epinephrine",
        "Intramuscular or subcutaneous glucagon (1 mg)",
        "Nitroglycerin"
      ],
      correct: "C"
    },
    {
      id: 15354,
      question: "What is anaphylaxis?",
      options: [
        "Mild allergic reaction",
        "An allergic reaction with immediate hypersensitivity",
        "Asthma attack",
        "Heart attack"
      ],
      correct: "B"
    },
    {
      id: 15355,
      question: "What are signs of anaphylaxis?",
      options: [
        "Mild itching only",
        "Rapid severe hives, swelling of mucous membranes, respiratory distress, wheezing",
        "Headache",
        "Nausea only"
      ],
      correct: "B"
    },
    {
      id: 15356,
      question: "For a responsive anaphylaxis patient, what should be administered?",
      options: [
        "Antihistamine",
        "Bronchodilator",
        "Epinephrine (0.15 mg for ≤30 kg; 0.3 to 0.5 mg for >30 kg)",
        "Nitroglycerin"
      ],
      correct: "C"
    },
    {
      id: 15357,
      question: "Can a repeat dose of epinephrine be considered for anaphylaxis?",
      options: [
        "No, never",
        "Yes, if ineffective and advanced care won\'t arrive within 5 to 10 minutes",
        "Only after 30 minutes",
        "Only if patient requests"
      ],
      correct: "B"
    },
    {
      id: 15358,
      question: "What is a localized skin response to an allergen?",
      options: [
        "Anaphylaxis",
        "Slow onset of mild itching, mild skin rash, hives",
        "Severe swelling",
        "Respiratory distress"
      ],
      correct: "B"
    },
    {
      id: 15359,
      question: "What medication should be administered for localized allergic skin response?",
      options: [
        "Epinephrine",
        "Nitroglycerin",
        "Diphenhydramine",
        "Glucagon"
      ],
      correct: "C"
    },
    {
      id: 15360,
      question: "What is the adult dose of diphenhydramine for localized allergic reaction?",
      options: [
        "10 mg",
        "15 to 20 mg",
        "25 to 50 mg",
        "100 mg"
      ],
      correct: "C"
    },
    {
      id: 15361,
      question: "What might cause toxicity from local anesthesia?",
      options: [
        "Too little anesthetic",
        "Sensitivity to ingredient or overdose",
        "Proper administration",
        "Using distilled water"
      ],
      correct: "B"
    },
    {
      id: 15362,
      question: "What are signs of local anesthetic toxicity?",
      options: [
        "Rash",
        "Lightheadedness, blurred vision, slurred speech, confusion, drowsiness",
        "High blood pressure",
        "Fever"
      ],
      correct: "B"
    },
    {
      id: 15363,
      question: "What are signs of toxicity from vasoconstrictor?",
      options: [
        "Slow pulse",
        "Anxiety, fast pulse, fast respirations, chest pain, possible dysrhythmias",
        "Low blood pressure",
        "Drowsiness"
      ],
      correct: "B"
    },
    {
      id: 15364,
      question: "For an avulsed tooth, what is the best immediate action?",
      options: [
        "Store in milk",
        "Immediately reimplant the tooth",
        "Throw it away",
        "Store in tap water"
      ],
      correct: "B"
    },
    {
      id: 15365,
      question: "If reimplantation of an avulsed tooth is not immediately possible, how should it be stored?",
      options: [
        "In tap water",
        "In alcohol",
        "In Hanks\' balanced salt solution or wrapped in cling film",
        "In ice"
      ],
      correct: "C"
    },
    {
      id: 15366,
      question: "Is storage of an avulsed tooth in tap water recommended?",
      options: [
        "Yes, highly recommended",
        "Yes, best option",
        "No, not recommended",
        "Only if nothing else available"
      ],
      correct: "C"
    },
    {
      id: 15367,
      question: "What is informed consent for emergency treatment?",
      options: [
        "Only written permission",
        "Permission obtained if patient is conscious; assumed if unconscious",
        "Never needed in emergencies",
        "Only needed from family"
      ],
      correct: "B"
    },
    {
      id: 15368,
      question: "Can emergency assistance begin immediately if a patient is unconscious?",
      options: [
        "No, must wait for family",
        "No, must get written consent",
        "Yes, permission can be assumed",
        "Only if EMS approves"
      ],
      correct: "C"
    },
    {
      id: 15369,
      question: "What is a Good Samaritan?",
      options: [
        "A healthcare worker on duty",
        "Someone who renders aid in an emergency to injured person on voluntary basis",
        "An EMS worker",
        "A hospital employee"
      ],
      correct: "B"
    },
    {
      id: 15370,
      question: "What do Good Samaritan statutes generally provide?",
      options: [
        "Financial compensation",
        "Immunity from civil liability for rendering care in emergency situations",
        "Mandatory duty to help",
        "Professional licensure"
      ],
      correct: "B"
    },
    {
      id: 15371,
      question: "What must be true for Good Samaritan protection?",
      options: [
        "Expect payment",
        "Emergency care at scene, proper training, acting gratuitously in good faith without remuneration",
        "Any care anywhere",
        "Only in hospitals"
      ],
      correct: "B"
    },
    {
      id: 15372,
      question: "Is gross negligence covered under Good Samaritan statutes?",
      options: [
        "Yes, always",
        "Yes, in most states",
        "No, not covered in most jurisdictions",
        "Only in some states"
      ],
      correct: "C"
    },
    {
      id: 15373,
      question: "What is gross negligence?",
      options: [
        "Minor error",
        "Accidental mistake",
        "Intentional failure to perform task with reckless disregard for consequences",
        "Honest mistake"
      ],
      correct: "C"
    },
    {
      id: 15374,
      question: "Can emergency care be denied if it\'s part of a person\'s job responsibilities?",
      options: [
        "Yes, always",
        "Yes, if off duty",
        "No, cannot be denied",
        "Only in certain situations"
      ],
      correct: "C"
    },
    {
      id: 15375,
      question: "What duty do dental hygienists have regarding emergency services?",
      options: [
        "No duty",
        "Duty to deliver emergency services within scope of their training",
        "Only call EMS",
        "Only observe"
      ],
      correct: "B"
    },
    {
      id: 15376,
      question: "What duty do all dental professionals have regarding competency?",
      options: [
        "No duty",
        "Remain competent through training, retraining, certification, and practice",
        "Only initial training",
        "Only if employer requires"
      ],
      correct: "B"
    }
  ],
  "1. Infection Control (Case Study)": [
    {
      id: 15377,
      question: "A dental hygienist is reviewing the basic infection prevention concepts before starting patient care. The primary objective of infection prevention and control in dental healthcare settings focuses on preventing which outcomes?",
      options: [
        "Healthcare-associated infections in patients and occupational injuries in personnel",
        "Cross-contamination of instruments and environmental surface contamination only",
        "Patient complaints about safety and regulatory compliance violations",
        "Equipment malfunction and dental material contamination during procedures",
      ],
      correct: "A"
    },
    {
      id: 15378,
      question: "When developing an infection control program, which model should guide the approach to patient safety?",
      options: [
        "The model should focus exclusively on reviewing individual patient health histories",
        "The model should be based on specific procedures rather than patient characteristics",
        "The model should target only patients with known infectious disease diagnoses",
        "The model should emphasize universal screening tests for all patients",
      ],
      correct: "B"
    },
    {
      id: 15379,
      question: "Which federal agency develops infection control guidelines and recommendations for healthcare settings but does NOT have regulatory enforcement authority?",
      options: [
        "Environmental Protection Agency (EPA) regulating chemical germicides",
        "Food and Drug Administration (FDA) regulating medical devices",
        "Centers for Disease Control and Prevention (CDC) developing guidelines",
        "Occupational Safety and Health Administration (OSHA) enforcing workplace safety",
      ],
      correct: "C"
    },
    {
      id: 15380,
      question: "The FDA's regulatory mission includes overseeing which aspects of infection control in dental settings?",
      options: [
        "Developing evidence-based guidelines for sterilization procedures only",
        "Regulating medical devices, ensuring product safety and effectiveness",
        "Enforcing workplace safety regulations for healthcare personnel",
        "Establishing drinking water quality standards for dental units",
      ],
      correct: "B"
    },
    {
      id: 15381,
      question: "During dental procedures, which of the following represents a potential route of pathogen transmission?",
      options: [
        "Contact with properly sterilized instruments stored in sealed packages",
        "Exposure to municipal water meeting EPA drinking water standards",
        "Direct contact with blood, oral fluids, or contaminated surfaces",
        "Breathing air in properly ventilated treatment rooms with HEPA filters",
      ],
      correct: "C"
    },
    {
      id: 15382,
      question: "For disease transmission to occur through the chain of infection, all of the following conditions must be present EXCEPT:",
      options: [
        "A pathogenic organism of sufficient virulence in adequate numbers",
        "A mode of transmission from the source to the host",
        "A previous documented exposure to the same pathogen",
        "A portal of entry through which the pathogen enters the host",
      ],
      correct: "C"
    },
    {
      id: 15383,
      question: "According to CDC guidelines, which represents one of the four fundamental principles of infection prevention and control?",
      options: [
        "Take action to stay healthy through immunizations and health programs",
        "Limit patient appointments to reduce overall infection exposure risks",
        "Screen all patients for infectious diseases before providing care",
        "Restrict treatment of immunocompromised patients to hospital settings",
      ],
      correct: "A"
    },
    {
      id: 15384,
      question: "Which vaccine series is OSHA-required for dental healthcare personnel at risk of blood exposure?",
      options: [
        "Annual influenza vaccine to prevent seasonal respiratory infections",
        "Hepatitis B vaccine series unless documentation of immunity exists",
        "Measles, mumps, rubella (MMR) vaccine for healthcare workers",
        "Tetanus-diphtheria (Td) booster every 10 years as recommended",
      ],
      correct: "B"
    },
    {
      id: 15385,
      question: "After completing the hepatitis B vaccine series, when should anti-HBs testing occur to verify immunity?",
      options: [
        "Immediately before receiving the first dose of the vaccine series",
        "Between the second and third doses to monitor response",
        "One to two months after completion of the third dose",
        "Annually to ensure continued protection against hepatitis B",
      ],
      correct: "C"
    },
    {
      id: 15386,
      question: "A dental healthcare professional with an active upper respiratory infection should:",
      options: [
        "Continue working with routine personal protective equipment (PPE) precautions",
        "Avoid contact with medically compromised patients as defined by ACIP",
        "Wear only a surgical mask while treating all scheduled patients",
        "Request reassignment to administrative duties for the entire month",
      ],
      correct: "B"
    },
    {
      id: 15387,
      question: "Which engineering control would MOST effectively prevent injuries from contaminated dental instruments?",
      options: [
        "Using automated ultrasonic cleaners for decontaminating used instruments",
        "Wearing heavy-duty utility gloves when handling all dental instruments",
        "Implementing strict hand hygiene protocols before and after procedures",
        "Posting warning signs in the sterilization area about sharp instruments",
      ],
      correct: "A"
    },
    {
      id: 15388,
      question: "An anesthetic syringe with a retractable needle or shielding mechanism represents which type of control measure?",
      options: [
        "Administrative control measure requiring policy changes and staff training",
        "Engineering control measure designed to eliminate or reduce hazards",
        "Work practice control measure altering how procedures are performed",
        "Personal protective equipment providing barriers against blood exposure",
      ],
      correct: "B"
    },
    {
      id: 15389,
      question: "According to infection control standards, the appropriate method for recapping used anesthetic needles is:",
      options: [
        "Using a two-handed technique to ensure proper needle coverage",
        "Having an assistant hold the cap while the clinician recaps",
        "Using a one-handed scoop technique or an engineering control device",
        "Placing needles directly into the sharps container without recapping",
      ],
      correct: "C"
    },
    {
      id: 15390,
      question: "Which work practice control reduces the likelihood of exposure to bloodborne pathogens during instrumentation?",
      options: [
        "Using cotton gauze wrapped around a finger to wipe instruments",
        "Passing instruments directly hand-to-hand between dental team members",
        "Using a stabilized sponge or cotton rolls to debride instruments",
        "Maintaining instruments in the oral cavity for extended periods",
      ],
      correct: "C"
    },
    {
      id: 15391,
      question: "For procedures that generate spray or droplets of blood or saliva, such as ultrasonic scaling, which PPE is required?",
      options: [
        "Gloves only, as saliva is not considered potentially infectious",
        "Mask, protective eyewear, gloves, and protective gown or lab coat",
        "Heavy-duty utility gloves and safety glasses for splash protection",
        "Disposable gown and examination gloves without face protection",
      ],
      correct: "B"
    },
    {
      id: 15392,
      question: "Which eye protection meets CDC and OSHA standards for dental healthcare settings?",
      options: [
        "Prescription eyeglasses without side shields or protective features",
        "Contact lenses worn alone to protect eyes from contamination",
        "Goggles, glasses with solid side shields, or face shields",
        "Reading glasses with anti-glare coating for improved visibility",
      ],
      correct: "C"
    },
    {
      id: 15393,
      question: "According to ASTM ratings recognized by the FDA, which level mask should be used for dental hygiene procedures with potential blood splatter?",
      options: [
        "Level 1 masks provide adequate protection for all dental procedures",
        "Level 2 or 3 masks should be used for procedures producing splatter",
        "Any mask meeting basic fluid resistance standards is acceptable",
        "Mask level is irrelevant as long as barriers are changed between patients",
      ],
      correct: "B"
    },
    {
      id: 15394,
      question: "When performing aerosol-generating procedures on patients with suspected airborne infections, which respiratory protection is recommended?",
      options: [
        "Standard surgical masks meeting Level 1 ASTM standards",
        "Cloth face coverings with multiple layers of fabric material",
        "NIOSH-approved N95 respirators or higher-level equivalents",
        "Face shields worn alone without additional respiratory protection",
      ],
      correct: "C"
    },
    {
      id: 15395,
      question: "Which protective clothing provides adequate barrier protection during routine dental hygiene procedures?",
      options: [
        "Scrubs worn alone without additional protective outer garments",
        "A long-sleeved lab coat worn over scrubs or street clothes",
        "Short-sleeved disposable gowns for all non-surgical procedures",
        "Street clothes with a disposable bib or apron covering the front",
      ],
      correct: "B"
    },
    {
      id: 15396,
      question: "According to OSHA regulations, who is responsible for arranging laundering of reusable protective clothing?",
      options: [
        "Employees must launder protective clothing at home using bleach",
        "A professional laundry service selected and paid by employees",
        "The employer must arrange and pay for proper laundering",
        "Either employer or employee depending on the practice policy",
      ],
      correct: "C"
    },
    {
      id: 15397,
      question: "A dental healthcare professional experiencing allergic reactions to glove materials should:",
      options: [
        "Continue using the same gloves while applying hand lotion more frequently",
        "Consult with a qualified healthcare professional for accurate diagnosis and treatment",
        "Immediately stop performing patient care until all symptoms completely resolve",
        "Switch to wearing gloves inside-out to reduce exposure to allergens",
      ],
      correct: "B"
    },
    {
      id: 15398,
      question: "Which statement about hand hygiene in dental settings is MOST accurate?",
      options: [
        "Hand hygiene with soap and water is required even when using alcohol-based hand rubs",
        "Alcohol-based hand rubs are preferred over soap and water when hands are not visibly soiled",
        "Rings and hand jewelry should be rotated regularly but may remain in place during hand hygiene",
        "Artificial fingernails are acceptable if kept shorter than 1/4 inch and cleaned thoroughly",
      ],
      correct: "B"
    },
    {
      id: 15399,
      question: "For surgical procedures, the appropriate hand hygiene method includes:",
      options: [
        "Routine handwash with plain soap and water for 15 seconds",
        "Antiseptic handrub with alcohol-based product until hands are dry",
        "Surgical antisepsis of hands and forearms for 2 to 6 minutes",
        "Standard handwash followed by donning sterile gloves immediately",
      ],
      correct: "C"
    },
    {
      id: 15400,
      question: "Which practice helps maintain skin integrity despite frequent hand hygiene procedures?",
      options: [
        "Using hot water to ensure thorough removal of microorganisms",
        "Wearing powdered gloves to absorb moisture and keep hands dry",
        "Thoroughly drying hands after washing and before donning gloves",
        "Limiting hand lotion use as it can interfere with glove integrity",
      ],
      correct: "C"
    },
    {
      id: 15401,
      question: "Critical instruments that penetrate soft tissue or bone require which level of processing between patients?",
      options: [
        "Cleaning with soap and water followed by intermediate-level disinfection",
        "Heat sterilization using autoclaves or acceptable equivalent methods",
        "High-level disinfection using EPA-registered chemical sterilants",
        "Barrier protection with single-use plastic sheaths changed between patients",
      ],
      correct: "B"
    },
    {
      id: 15402,
      question: "Which instrument classification accurately describes mouth mirrors and impression trays?",
      options: [
        "Critical instruments requiring sterilization because they penetrate soft tissue",
        "Semicritical instruments contacting mucous membranes requiring sterilization",
        "Noncritical instruments contacting intact skin requiring only low-level disinfection",
        "Disposable instruments that must be discarded after single patient use",
      ],
      correct: "B"
    },
    {
      id: 15403,
      question: "The instrument reprocessing workflow should follow which directional pattern to prevent cross-contamination?",
      options: [
        "Bidirectional flow allowing staff to move between dirty and clean areas freely",
        "One-directional flow from receiving through cleaning, packaging, sterilization, and storage",
        "Circular flow pattern with soiled and sterile instruments processed in same space",
        "Random flow pattern as long as staff wear appropriate personal protective equipment",
      ],
      correct: "B"
    },
    {
      id: 15404,
      question: "Used contaminated instruments should be transported in which type of container?",
      options: [
        "An open instrument tray covered with a disposable paper towel",
        "A clear plastic bag sealed and hand-carried by staff member",
        "A solid-sided container labeled with the universal biohazard symbol",
        "The same sterile pouches used for storing sterilized instruments",
      ],
      correct: "C"
    },
    {
      id: 15405,
      question: "Before instrument sterilization, instruments heavily soiled with blood or organic material should be:",
      options: [
        "Placed directly into the steam autoclave for extended sterilization cycles",
        "Pretreated with an enzyme-containing presoak or prespray product",
        "Wiped with alcohol-based disinfectant and immediately sterilized",
        "Stored dry until the end of the day for batch processing",
      ],
      correct: "B"
    },
    {
      id: 15406,
      question: "Which instrument cleaning method provides superior cleaning compared to hand scrubbing?",
      options: [
        "Wiping instruments with gauze sponges soaked in disinfectant solution",
        "Manual scrubbing with brushes under running water with detergent",
        "Automated devices such as ultrasonic cleaners or instrument washers",
        "Soaking instruments overnight in cold chemical sterilant solutions",
      ],
      correct: "C"
    },
    {
      id: 15407,
      question: "When using a dynamic air removal steam sterilizer, which test should be performed at the beginning of each day?",
      options: [
        "Bowie-Dick air removal test to ensure all air is evacuated from the chamber",
        "Chemical indicator strip test placed inside every instrument package",
        "Biological indicator spore test to verify destruction of resistant organisms",
        "Temperature monitoring test using external thermometer devices",
      ],
      correct: "A"
    },
    {
      id: 15408,
      question: "When loading paper/plastic pouches in a steam sterilizer, the pouches should be positioned:",
      options: [
        "Stacked flat in multiple layers to maximize sterilizer capacity",
        "Placed on their sides with paper facing plastic of adjacent pouches",
        "Arranged vertically standing upright to promote drainage",
        "Overlapped to ensure efficient use of available chamber space",
      ],
      correct: "B"
    },
    {
      id: 15409,
      question: "A dynamic air removal sterilizer offers which advantage compared to gravity displacement sterilizers?",
      options: [
        "Longer sterilization cycles ensuring complete destruction of all organisms",
        "Lower temperatures that prevent damage to heat-sensitive materials",
        "Better steam penetration into lumens with shorter sterilization cycles",
        "Elimination of the need for daily air removal testing",
      ],
      correct: "C"
    },
    {
      id: 15410,
      question: "According to CDC recommendations, biological indicator spore testing of sterilizers should be performed:",
      options: [
        "Only when the sterilizer malfunctions or produces incomplete sterilization results",
        "At least weekly and with every load containing implantable devices",
        "Monthly during routine practice operations and quarterly during slow periods",
        "Daily at the beginning and end of each clinical day for all sterilizers",
      ],
      correct: "B"
    },
    {
      id: 15411,
      question: "Chemical indicators on sterilization pouches indicate:",
      options: [
        "Complete sterilization and destruction of all viable organisms including spores",
        "Exposure to certain parameters such as heat or steam during processing",
        "The instruments inside are safe for immediate patient use without concerns",
        "Biological indicators are unnecessary if chemical indicators show proper color change",
      ],
      correct: "B"
    },
    {
      id: 15412,
      question: "Which method provides the highest level of sterility assurance for instrument reprocessing?",
      options: [
        "Chemical indicators showing proper color change on sterilization pouches",
        "Mechanical indicators displaying correct temperature and pressure readings",
        "Biological indicators confirming destruction of highly resistant bacterial spores",
        "Visual inspection of instrument packages for tears or moisture contamination",
      ],
      correct: "C"
    },
    {
      id: 15413,
      question: "Geobacillus stearothermophilus spores are the standard biological indicator organism for monitoring which sterilization methods?",
      options: [
        "Dry heat sterilization using high temperatures and extended cycle times",
        "Steam and chemical vapor sterilization in healthcare facilities",
        "Ethylene oxide gas sterilization for heat-sensitive instruments",
        "Cold chemical sterilization using liquid glutaraldehyde solutions",
      ],
      correct: "B"
    },
    {
      id: 15414,
      question: "For nonsurgical dental procedures, the CDC recommends that dental unit water should meet which standard?",
      options: [
        "Sterile water quality with zero colony-forming units per milliliter",
        "Distilled water quality equivalent to water used in laboratories",
        "Drinking water standards with ≤500 CFU/mL heterotrophic bacteria",
        "Tap water quality as supplied by municipal water treatment facilities",
      ],
      correct: "C"
    },
    {
      id: 15415,
      question: "Which approach helps achieve CDC-recommended water quality for routine dental procedures?",
      options: [
        "Using municipal tap water alone in self-contained dental unit water reservoirs",
        "Filling independent water reservoirs with sterile water without additional treatment",
        "Combining independent water reservoirs with chemical treatment or filtration systems",
        "Flushing waterlines for 20-30 seconds at the beginning of the day only",
      ],
      correct: "C"
    },
    {
      id: 15416,
      question: "During oral surgical procedures, which type of irrigant should be used for cooling and irrigation?",
      options: [
        "Treated dental unit water meeting drinking water quality standards",
        "Sterile solutions delivered through sterile single-use devices",
        "Distilled water from the dental unit's independent water reservoir",
        "Tap water that has been filtered through a 0.2 micron filter",
      ],
      correct: "B"
    },
    {
      id: 15417,
      question: "Chemical treatment products for dental unit waterlines are regulated by which agencies?",
      options: [
        "Continuous treatment products by FDA and intermittent treatment products by EPA",
        "All waterline treatment products by EPA as environmental disinfectants",
        "All waterline treatment products by FDA as medical devices",
        "Continuous treatment by EPA and intermittent treatment by CDC",
      ],
      correct: "A"
    },
    {
      id: 15418,
      question: "Clinical contact surfaces contaminated during patient care should be:",
      options: [
        "Cleaned with soap and water only if visibly soiled with blood",
        "Covered with barriers changed between patients or cleaned and disinfected",
        "Cleaned weekly using EPA-registered low-level disinfectants",
        "Left untreated if the patient has no known infectious diseases",
      ],
      correct: "B"
    },
    {
      id: 15419,
      question: "Surfaces with visible blood or other potentially infectious materials should be cleaned and disinfected with:",
      options: [
        "Soap and water followed by thorough drying with paper towels",
        "Alcohol-based hand sanitizer applied directly to contaminated surfaces",
        "EPA-registered hospital disinfectant with a tuberculocidal claim (intermediate-level)",
        "Diluted household bleach solutions prepared weekly and stored in spray bottles",
      ],
      correct: "C"
    },
    {
      id: 15420,
      question: "Which personal protective equipment should be worn during environmental surface cleaning and disinfection?",
      options: [
        "Examination gloves provide adequate protection for all surface disinfection tasks",
        "Chemical and puncture-resistant utility gloves with additional PPE as needed",
        "No gloves are necessary when using EPA-registered disinfectants",
        "Sterile surgical gloves to prevent contamination of disinfected surfaces",
      ],
      correct: "B"
    },
    {
      id: 15421,
      question: "Which surfaces are appropriate candidates for protection with impervious surface barriers?",
      options: [
        "Operatory floors and walls that are easy to clean and disinfect thoroughly",
        "Dental unit light handles, chair controls, and difficult-to-clean switches",
        "Countertops and flat surfaces that can be easily wiped with disinfectant",
        "Instrument cassettes and trays used to organize dental instruments",
      ],
      correct: "B"
    },
    {
      id: 15422,
      question: "Immediately after a percutaneous injury with a contaminated instrument, the hygienist should:",
      options: [
        "Apply pressure to the wound to prevent bleeding and potential contamination",
        "Wash the area with soap and water or flush with saline or sterile irrigants",
        "Apply household bleach directly to the wound to kill bloodborne pathogens",
        "Squeeze or \"milk\" the wound to express blood and remove contaminants",
      ],
      correct: "B"
    },
    {
      id: 15423,
      question: "According to postexposure management protocols, the exposed employee should:",
      options: [
        "Wait 24 hours to see if symptoms develop before seeking medical evaluation",
        "Complete an incident report within 7 days and schedule routine followup",
        "Receive immediate referral to a qualified healthcare professional for evaluation",
        "Monitor the exposure site for 30 days before determining need for testing",
      ],
      correct: "C"
    },
    {
      id: 15424,
      question: "For an unvaccinated healthcare worker exposed to blood from an HBV-positive source, postexposure management should include:",
      options: [
        "Immediate vaccination with hepatitis B vaccine series with no additional prophylaxis needed",
        "Hepatitis B immune globulin administration and initiation of HBV vaccine series",
        "Wait-and-see approach with monthly monitoring for 6 months post-exposure",
        "Administration of broad-spectrum antibiotics to prevent HBV infection",
      ],
      correct: "B"
    },
    {
      id: 15425,
      question: "A previously vaccinated healthcare worker with documented immunity to HBV who is exposed to HBsAg-positive blood requires:",
      options: [
        "Immediate administration of hepatitis B immune globulin and revaccination",
        "A booster dose of hepatitis B vaccine within 24 hours of exposure",
        "No postexposure prophylaxis because of existing documented immunity",
        "Anti-HBs titer testing every week for one month after exposure",
      ],
      correct: "C"
    },
    {
      id: 15426,
      question: "When should HIV postexposure prophylaxis (PEP) be initiated following occupational exposure?",
      options: [
        "Within 2 hours of exposure for maximum effectiveness against HIV infection",
        "Within 72 hours after confirming the source patient's HIV-positive status",
        "After baseline HIV testing confirms the exposed worker is HIV-negative",
        "Only if the exposed healthcare worker develops flu-like symptoms",
      ],
      correct: "A"
    },
    {
      id: 15427,
      question: "A written postexposure management program must include which essential component?",
      options: [
        "Annual training for all staff on proper techniques for recapping needles",
        "Procedures for prompt reporting, evaluation, counseling, and followup",
        "Requirement that all employees receive monthly bloodborne pathogen testing",
        "Protocols for immediate termination of patients with known infectious diseases",
      ],
      correct: "B"
    },
    {
      id: 15428,
      question: "The average risk of HIV infection following a percutaneous exposure to HIV-infected blood is approximately:",
      options: [
        "Less than 0.3%, which is relatively low but requires postexposure management",
        "6-30%, depending on the viral load and depth of injury",
        "1.8%, similar to the risk of hepatitis C transmission",
        "50% without immediate postexposure prophylaxis within 2 hours",
      ],
      correct: "A"
    },
    {
      id: 15429,
      question: "There is no vaccine for hepatitis C. After exposure to HCV-positive blood, which management is appropriate?",
      options: [
        "Administration of hepatitis C immune globulin within 24 hours of exposure",
        "Immediate antiviral prophylaxis with interferon and ribavirin combination therapy",
        "Testing of source patient and exposed worker with followup HCV RNA testing",
        "No followup is necessary as HCV is not transmitted through needlestick injuries",
      ],
      correct: "C"
    },
    {
      id: 15430,
      question: "Standard Precautions apply to which substances during patient care?",
      options: [
        "Blood only, as other body fluids have low infectivity potential",
        "Blood and other body fluids, secretions, and excretions except sweat",
        "Blood and saliva only, as these are the primary fluids in dentistry",
        "All patient body fluids including sweat and tears during dental procedures",
      ],
      correct: "B"
    },
    {
      id: 15431,
      question: "A patient with a history of tuberculosis treatment should be:",
      options: [
        "Treated using only standard precautions with routine personal protective equipment",
        "Evaluated away from other patients and assessed for current TB infectiousness",
        "Referred immediately to a hospital for all dental treatment permanently",
        "Treated with windows open and fans running to dilute airborne organisms",
      ],
      correct: "B"
    },
    {
      id: 15432,
      question: "These symptoms may indicate tuberculosis infection. The hygienist should:",
      options: [
        "Proceed with scheduled treatment using an N95 respirator only",
        "Ask the patient to cover their mouth with tissues during treatment",
        "Defer elective treatment and refer patient to physician for medical evaluation",
        "Provide treatment as scheduled because TB cannot spread during dental care",
      ],
      correct: "C"
    },
    {
      id: 15433,
      question: "Transmission-based precautions in dental settings are indicated for diseases transmitted by which routes?",
      options: [
        "Only bloodborne routes through percutaneous injuries with sharp instruments",
        "Airborne, droplet, or contact routes when standard precautions are insufficient",
        "Foodborne routes through contaminated water in dental unit waterlines",
        "Vector-borne routes through insects in the dental office environment",
      ],
      correct: "B"
    },
    {
      id: 15434,
      question: "A patient with acute influenza should:",
      options: [
        "Be treated in a typical outpatient dental office with standard precautions only",
        "Not seek routine dental care while infectious and postpone elective treatment",
        "Wear a cloth face covering and receive treatment as normally scheduled",
        "Be treated first each day before the office becomes contaminated",
      ],
      correct: "B"
    },
    {
      id: 15435,
      question: "Which individual should be designated as the infection prevention coordinator in a dental practice?",
      options: [
        "The office receptionist who manages appointment scheduling",
        "The newest employee who recently completed infection control training",
        "A designated person or committee responsible for implementing the program",
        "The dental equipment sales representative providing sterilization equipment",
      ],
      correct: "C"
    },
    {
      id: 15436,
      question: "Demonstrating a culture of safety in a dental practice includes:",
      options: [
        "Hiding infection control procedures from patients to avoid causing anxiety",
        "Explaining infection prevention practices to patients and answering questions",
        "Performing infection control only when treating patients with known infections",
        "Limiting infection control education to annual mandatory training sessions",
      ],
      correct: "B"
    },
    {
      id: 15437,
      question: "OSHA requires employers to offer hepatitis B vaccination under which circumstances?",
      options: [
        "Only to employees who specifically request vaccination and complete consent forms",
        "To all personnel at risk of blood exposure unless verification of immunity exists",
        "Exclusively to dental hygienists and dentists who provide direct patient care",
        "Only after an employee experiences an occupational exposure to blood",
      ],
      correct: "B"
    },
    {
      id: 15438,
      question: "If an employee initially declined HBV vaccination but later decides to accept it, the employer must:",
      options: [
        "Require the employee to pay for the vaccine series if declining the initial offer",
        "Make the HBV vaccination available at no cost to the employee at that time",
        "Wait until the next annual open enrollment period to offer vaccination again",
        "Document that the employee forfeited their right to vaccination by declining initially",
      ],
      correct: "B"
    },
    {
      id: 15439,
      question: "To maintain hand health while performing frequent hand hygiene, the healthcare worker should:",
      options: [
        "Use hot water when washing hands to ensure thorough microbial removal",
        "Skip hand hygiene between some patients to allow skin to recover",
        "Use cool water, thoroughly dry hands, and frequently apply hand lotion",
        "Wear gloves continuously throughout the day without removing them",
      ],
      correct: "C"
    },
    {
      id: 15440,
      question: "According to CDC hand hygiene recommendations, jewelry and rings should be:",
      options: [
        "Cleaned with alcohol-based hand rub before donning gloves for each patient",
        "Removed before performing hand hygiene procedures in healthcare settings",
        "Rotated to different fingers weekly to allow thorough cleaning underneath",
        "Covered with gloves making removal unnecessary during patient care",
      ],
      correct: "B"
    },
    {
      id: 15441,
      question: "Healthcare personnel performing direct patient care should:",
      options: [
        "Keep artificial fingernails trimmed to less than 1/4 inch beyond the fingertip",
        "Not wear artificial fingernails or extenders when having direct patient contact",
        "Clean artificial fingernails with a nailbrush for 2 minutes before each patient",
        "Wear double gloves when artificial fingernails or nail extenders are present",
      ],
      correct: "B"
    },
    {
      id: 15442,
      question: "Which technique reduces the amount of aerosol and spatter during dental hygiene procedures?",
      options: [
        "Using low-speed suction or no suction while spraying with an air-water syringe",
        "Using high-speed evacuation while operating ultrasonic scalers and handpieces",
        "Positioning the patient in a fully upright position during aerosol-generating procedures",
        "Aiming the air-water syringe directly at the oral tissues at maximum pressure",
      ],
      correct: "B"
    },
    {
      id: 15443,
      question: "Creating a neutral zone for passing sharps between dental team members serves which purpose?",
      options: [
        "Providing a location to store instruments during the procedure for easy access",
        "Avoiding direct hand-to-hand passing of sharps between healthcare personnel",
        "Designating an area for disposing of single-use items during treatment",
        "Establishing a location for placing sterile instruments before use",
      ],
      correct: "B"
    },
    {
      id: 15444,
      question: "Bacillus pumilus spores are the most resistant organisms used to test which sterilization method?",
      options: [
        "Steam autoclave sterilization in gravity or dynamic air removal sterilizers",
        "Unsaturated chemical vapor sterilization using formaldehyde-based vapors",
        "Dry heat sterilization at high temperatures for extended time periods",
        "Ethylene oxide gas sterilization for heat-sensitive instruments and materials",
      ],
      correct: "C"
    },
    {
      id: 15445,
      question: "Used anesthetic needles and scalpel blades should be disposed in which type of container?",
      options: [
        "Regular waste containers lined with red biohazard bags",
        "Rigid, puncture-resistant sharps containers properly labeled",
        "Sealable plastic bags designated for biohazardous waste",
        "Cardboard boxes labeled with the universal biohazard symbol",
      ],
      correct: "B"
    },
    {
      id: 15446,
      question: "While wearing contaminated gloves during treatment, the hygienist should:",
      options: [
        "Remove gloves, adjust the light, perform hand hygiene, and reglove before continuing",
        "Use a surface barrier on the light handle or remove gloves before touching it",
        "Continue using contaminated gloves as the light will be disinfected later",
        "Ask another team member to touch all surfaces while maintaining contaminated gloves",
      ],
      correct: "B"
    },
    {
      id: 15447,
      question: "Medical examination gloves for nonsurgical dental procedures should be:",
      options: [
        "Sterile gloves individually packaged in sized pairs for proper fit",
        "Nonsterile gloves available in various sizes and materials",
        "Heavy-duty utility gloves that are puncture-resistant",
        "Single-size ambidextrous gloves made exclusively from latex",
      ],
      correct: "B"
    },
    {
      id: 15448,
      question: "Upon discovering a torn, cut, or punctured glove during patient treatment, the hygienist should:",
      options: [
        "Continue the procedure and change gloves at the next convenient stopping point",
        "Cover the tear with tape or a finger cot and continue treatment",
        "Immediately remove the gloves, wash hands, and reglove before continuing",
        "Switch the torn glove to the non-dominant hand where there is less contact",
      ],
      correct: "C"
    },
    {
      id: 15449,
      question: "Sterile surgeon's gloves are specifically indicated for which dental procedures?",
      options: [
        "All dental hygiene procedures including examination and scaling",
        "Oral surgical procedures such as periodontal surgery and tooth extractions",
        "Any procedure involving contact with blood, saliva, or mucous membranes",
        "Routine prophylaxis, sealant placement, and fluoride application",
      ],
      correct: "B"
    },
    {
      id: 15450,
      question: "When using a gravity displacement autoclave compared to dynamic air removal, sterilization cycles are typically:",
      options: [
        "Shorter because gravity efficiently removes all air from the chamber",
        "The same length as dynamic air removal for all instrument types",
        "Longer because gravity displacement is less efficient at removing air",
        "Unnecessary because gravity displacement does not require sterilization time",
      ],
      correct: "C"
    },
    {
      id: 15451,
      question: "Records of biological indicator spore testing results should be:",
      options: [
        "Discarded immediately after verifying negative results",
        "Maintained according to state regulations and practice policy",
        "Kept for only 30 days before being destroyed",
        "Sent to the CDC for national infection control surveillance",
      ],
      correct: "B"
    },
    {
      id: 15452,
      question: "High-level disinfectants are indicated for semicritical items that:",
      options: [
        "Can be heat sterilized but the practice prefers using chemicals",
        "Contact intact skin but not mucous membranes during use",
        "Contact mucous membranes but cannot be heat sterilized",
        "Penetrate soft tissue and require sterilization between uses",
      ],
      correct: "C"
    },
    {
      id: 15453,
      question: "When treating a patient known to have hepatitis B infection, the dental hygienist should:",
      options: [
        "Refer the patient to a specialist hospital for all dental treatment",
        "Use standard precautions the same as for all other patients",
        "Wear double gloves and use dedicated instruments for this patient only",
        "Schedule this patient at the end of the day to perform terminal disinfection",
      ],
      correct: "B"
    },
    {
      id: 15454,
      question: "During epidemics or pandemics involving airborne diseases, dental healthcare personnel should:",
      options: [
        "Continue routine practice operations using only standard precautions",
        "Follow public health guidelines and implement transmission-based precautions",
        "Close the practice until public health declares the outbreak is completely over",
        "Treat only emergency patients with known exposure to infectious diseases",
      ],
      correct: "B"
    },
    {
      id: 15455,
      question: "Used impression trays and impression materials contaminated with blood or saliva should be:",
      options: [
        "Rinsed with water and stored in a plastic bag until the case returns",
        "Cleaned, disinfected following manufacturer's recommendations, and dried",
        "Wrapped in gauze moistened with disinfectant for transport to the laboratory",
        "Sprayed with alcohol-based disinfectant and sent immediately to the laboratory",
      ],
      correct: "B"
    },
    {
      id: 15456,
      question: "To reduce disease transmission during epidemic respiratory illness outbreaks, patients should be instructed to:",
      options: [
        "Reschedule appointments if they have symptoms of respiratory infection",
        "Take prophylactic antibiotics before dental appointments during flu season",
        "Wear examination gloves to prevent spreading germs by hand contact",
        "Remove face masks upon entering the office to allow normal breathing",
      ],
      correct: "A"
    },
    {
      id: 15457,
      question: "Digital radiography sensors that cannot be heat sterilized or subjected to high-level disinfection should be:",
      options: [
        "Cleaned with soap and water and used immediately on the next patient",
        "Protected with barriers changed for each patient and underlying surfaces cleaned if exposed",
        "Soaked in intermediate-level disinfectant for 10 minutes between patients",
        "Dedicated to individual patients and not used on multiple patients in one day",
      ],
      correct: "B"
    },
    {
      id: 15458,
      question: "Chemical indicators should be placed:",
      options: [
        "Only on the outside of packages where they can be easily visualized",
        "Inside every packet with external indicators if internal indicator not visible",
        "Exclusively in weekly biological indicator test packs for monitoring",
        "On the outside of alternating packages to reduce supply costs",
      ],
      correct: "B"
    },
    {
      id: 15459,
      question: "When explaining infection control to patients, the hygienist should emphasize that these practices:",
      options: [
        "Are required by law but provide minimal actual protection against disease",
        "Protect both patients and dental healthcare personnel from disease transmission",
        "Are only necessary when treating patients with known infectious diseases",
        "Focus primarily on protecting the dental team rather than patients",
      ],
      correct: "B"
    },
    {
      id: 15460,
      question: "High-speed suction disposable tips should be:",
      options: [
        "Changed weekly or when visibly soiled with debris or blood",
        "Changed for each patient to prevent cross-contamination",
        "Cleaned and disinfected between patients and changed monthly",
        "Used for an entire day and disposed of at day's end",
      ],
      correct: "B"
    },
    {
      id: 15461,
      question: "After removing instrument packs from the sterilizer, sterile packs should be:",
      options: [
        "Used immediately while still warm to prevent recontamination",
        "Stored in a dry area away from contamination until needed",
        "Placed in the refrigerator to cool down before storage",
        "Unwrapped to allow air circulation and prevent moisture buildup",
      ],
      correct: "B"
    },
    {
      id: 15462,
      question: "Ultrasonic scalers with independent water reservoirs used for nonsurgical procedures should use water that:",
      options: [
        "Meets sterile water standards with zero microorganisms present",
        "Comes directly from municipal tap water without treatment",
        "Meets drinking water standards with appropriate biofilm control",
        "Has been boiled for 10 minutes and cooled before use",
      ],
      correct: "C"
    },
    {
      id: 15463,
      question: "Dental handpieces should be:",
      options: [
        "Wiped with intermediate-level disinfectant and covered with barriers",
        "Heat sterilized between patients according to manufacturer's instructions",
        "Flushed with water and alcohol for 30 seconds between patients",
        "Cleaned with soap and water and allowed to air dry overnight",
      ],
      correct: "B"
    },
    {
      id: 15464,
      question: "During instrument cleaning and processing until removal of sterile packs from the sterilizer, staff should wear:",
      options: [
        "Examination gloves only, as instruments are being cleaned",
        "Heavy-duty gloves, face protection, and protective gown or lab coat",
        "Sterile surgical gloves to prevent contaminating cleaned instruments",
        "No gloves during cleaning since instruments will be sterilized",
      ],
      correct: "B"
    },
    {
      id: 15465,
      question: "After mucous membrane exposure to potentially infectious saliva, the exposed area should be:",
      options: [
        "Vigorously rubbed with gauze to remove contaminants",
        "Flushed immediately with clean water, saline, or sterile irrigants",
        "Treated with antiseptic eye drops to kill microorganisms",
        "Left alone as tears will naturally flush the contaminants",
      ],
      correct: "B"
    },
    {
      id: 15466,
      question: "Paper patient bibs, gauze, and cotton rolls contaminated with saliva should be disposed of in:",
      options: [
        "Regulated medical waste containers designated for infectious waste",
        "Sharps containers to prevent potential exposure to bloodborne pathogens",
        "Regular trash as they are not considered regulated medical waste",
        "Recycling containers after disinfection to promote environmental sustainability",
      ],
      correct: "C"
    },
    {
      id: 15467,
      question: "The CDC provides which tool for dental practices to assess compliance with infection prevention recommendations?",
      options: [
        "Annual survey conducted by CDC inspectors visiting dental offices",
        "Online certification examination testing knowledge of infection control",
        "Infection Prevention Checklist for Dental Settings for self-assessment",
        "Mandatory reporting system for all infection control breaches",
      ],
      correct: "C"
    },
    {
      id: 15468,
      question: "Diluted bleach solutions for environmental surface disinfection should be:",
      options: [
        "Prepared annually and stored in sealed containers away from light",
        "Purchased premixed and stored according to manufacturer's expiration dates",
        "Prepared daily or according to manufacturer's recommendations for diluted solutions",
        "Mixed at any concentration as bleach is effective at all dilutions",
      ],
      correct: "C"
    },
    {
      id: 15469,
      question: "During a boil-water advisory affecting municipal water supplies, a dental practice should:",
      options: [
        "Continue using tap water for patient care as dental equipment sterilizes water",
        "Use only water from self-contained reservoirs or bottled water for patient care",
        "Close the practice until the advisory is lifted by public health authorities",
        "Boil water for exactly 1 minute and use immediately while still hot",
      ],
      correct: "B"
    },
    {
      id: 15470,
      question: "The infection control model differs from traditional patient care models because it focuses primarily on:",
      options: [
        "Individual patient health history and documented infectious disease status",
        "Tasks and procedures to protect both patients and providers",
        "Treating only patients with verified negative infectious disease testing",
        "Cost-effectiveness of infection control supplies and equipment",
      ],
      correct: "B"
    },
    {
      id: 15471,
      question: "Housekeeping surfaces such as floors, walls, and sinks should be:",
      options: [
        "Cleaned with soap and water or disinfected if visibly contaminated with blood",
        "Disinfected with tuberculocidal disinfectants after every patient regardless of contamination",
        "Sterilized using autoclaves or chemical sterilants on a weekly basis",
        "Covered with impervious barriers that are changed between each patient",
      ],
      correct: "A"
    },
    {
      id: 15472,
      question: "Instrument packs that are wet or show moisture after the sterilization cycle should be:",
      options: [
        "Used immediately before moisture allows microbial growth",
        "Considered contaminated and reprocessed before use",
        "Air-dried for 24 hours and then stored with other sterile packs",
        "Wiped with sterile towels to remove moisture before storage",
      ],
      correct: "B"
    },
    {
      id: 15473,
      question: "Protective gowns or lab coats contaminated during patient care should be:",
      options: [
        "Removed and laundered at home using hot water and household bleach",
        "Worn throughout the day and removed only at the end of clinical hours",
        "Removed before leaving the work area and laundered by employer",
        "Worn continuously including during lunch breaks and when running errands",
      ],
      correct: "C"
    },
    {
      id: 15474,
      question: "If a sterilizer malfunctions or biological indicator testing shows sterilization failure, the practice should:",
      options: [
        "Continue using the sterilizer until it can be serviced at the next scheduled maintenance",
        "Recall instruments from the affected load and reprocess before use on patients",
        "Increase sterilization time to compensate for the malfunction",
        "Use only chemical indicators instead of biological monitoring until repaired",
      ],
      correct: "B"
    },
    {
      id: 15475,
      question: "The majority of occupational exposures to bloodborne pathogens in dental settings occur through:",
      options: [
        "Splash exposure to mucous membranes of the eyes, nose, or mouth",
        "Needlestick or other percutaneous injuries with contaminated sharp devices",
        "Contact with nonintact skin during provision of patient care",
        "Inhalation of aerosols generated during dental procedures",
      ],
      correct: "B"
    },
    {
      id: 15476,
      question: "According to OSHA, which type of control is MOST effective in reducing workplace injury risk?",
      options: [
        "Administrative controls such as written policies and staff training programs",
        "Engineering controls such as devices that eliminate or remove hazards",
        "Work practice controls altering the way tasks or procedures are performed",
        "Personal protective equipment providing barriers between worker and hazard",
      ],
      correct: "B"
    }
  ],
  "2. Medical Emergencies in Dentistry (Case Study)": [
    {
      id: 15477,
      question: "Which factor has contributed to the increased likelihood of medical emergencies in dental settings?",
      options: [
        "Decreased number of medically compromised individuals seeking dental care",
        "Increased number of invasive procedures and longer appointment times",
        "Reduced use of local anesthetics and sedatives in dental practice",
        "Decreased availability of emergency drugs and equipment in offices",
      ],
      correct: "B"
    },
    {
      id: 15478,
      question: "All oral healthcare personnel should maintain current certification in which level of emergency training?",
      options: [
        "Advanced Cardiac Life Support (ACLS) appropriate for hospital settings",
        "Basic Life Support (BLS) appropriate for their practice environment",
        "Pediatric Advanced Life Support (PALS) for treating children only",
        "Emergency Medical Technician (EMT) certification for advanced interventions",
      ],
      correct: "B"
    },
    {
      id: 15479,
      question: "Emergency contact information that should be posted includes all of the following EXCEPT:",
      options: [
        "Local emergency medical services (EMS) number and poison control center",
        "Office address with room numbers for directing emergency personnel",
        "Personal cell phone numbers of all staff members' family contacts",
        "Local police and fire department telephone numbers for emergencies",
      ],
      correct: "C"
    },
    {
      id: 15480,
      question: "At minimum, the basic emergency drug kit should include which combination of medications?",
      options: [
        "Antibiotics, antivirals, antifungals, and sterile water for injections",
        "Epinephrine, histamine blocker, nitroglycerin, bronchodilator, and aspirin",
        "Narcotic analgesics, muscle relaxants, anti-anxiety drugs, and sedatives",
        "Antihypertensives, diuretics, anticoagulants, and cardiac glycosides",
      ],
      correct: "B"
    },
    {
      id: 15481,
      question: "A dental practice that administers opioids should include which reversal agent in the emergency kit?",
      options: [
        "Flumazenil (Romazicon) to reverse benzodiazepine effects only",
        "Atropine sulfate to increase heart rate and reverse bradycardia",
        "Naloxone (Narcan) to reverse opioid overdose by blocking effects",
        "Adenosine to convert supraventricular tachycardia to normal rhythm",
      ],
      correct: "C"
    },
    {
      id: 15482,
      question: "In the United States, portable oxygen tanks used in dental settings are typically which color?",
      options: [
        "White tanks following international standards for medical gas coding",
        "Green tanks following U.S. standards, though colors vary internationally",
        "Blue tanks designated specifically for dental office use only",
        "Yellow tanks indicating compressed oxygen for healthcare facilities",
      ],
      correct: "B"
    },
    {
      id: 15483,
      question: "Before administering supplemental oxygen, the hygienist should first assess oxygen saturation using:",
      options: [
        "A stethoscope to auscultate breath sounds bilaterally in all fields",
        "Visual inspection of skin color and assessment of respiratory rate",
        "A pulse oximeter to measure peripheral capillary oxygen saturation",
        "Blood pressure measurement to determine cardiovascular perfusion status",
      ],
      correct: "C"
    },
    {
      id: 15484,
      question: "For a stable patient with peripheral capillary oxygen saturation (SpO2) of 90% to 94%, the hygienist should:",
      options: [
        "Immediately administer high-flow oxygen at 15 liters per minute",
        "Consider that supplemental oxygen may not be required at this level",
        "Activate emergency medical services for emergency transport immediately",
        "Administer epinephrine and prepare for cardiopulmonary resuscitation",
      ],
      correct: "B"
    },
    {
      id: 15485,
      question: "When initiating oxygen therapy, the lowest concentration should be delivered via which method?",
      options: [
        "Nonrebreather mask at maximum flow rate of 15 liters per minute",
        "Simple face mask starting at 6 liters per minute flow rate",
        "Nasal cannula at 2 liters per minute flow rate initially",
        "Bag-valve-mask with 100% oxygen at 15 liters per minute",
      ],
      correct: "C"
    },
    {
      id: 15486,
      question: "A size E oxygen cylinder will supply approximately how much oxygen delivery time?",
      options: [
        "10 minutes of continuous oxygen delivery at standard flow rates",
        "30 minutes of continuous oxygen delivery at standard flow rates",
        "60 minutes of continuous oxygen delivery at standard flow rates",
        "120 minutes of continuous oxygen delivery at standard flow rates",
      ],
      correct: "B"
    },
    {
      id: 15487,
      question: "Which document should be given to EMS personnel and accompany the patient to the hospital?",
      options: [
        "The patient's insurance information and payment authorization forms",
        "Complete dental treatment records from all previous appointments",
        "Emergency medical report with vital signs and treatments administered",
        "Office policies and consent forms signed at the initial appointment",
      ],
      correct: "C"
    },
    {
      id: 15488,
      question: "A patient classified as ASA I represents which treatment consideration?",
      options: [
        "\"Red light\" requiring hospitalization for any dental treatment procedures",
        "\"Yellow light\" requiring caution and modifications before proceeding",
        "\"Green light\" indicating normal health and minimal risk for complications",
        "\"Orange light\" requiring advanced cardiac life support personnel present",
      ],
      correct: "C"
    },
    {
      id: 15489,
      question: "This patient's physical status would be classified as which ASA category?",
      options: [
        "ASA I indicating normal health without systemic disease",
        "ASA II indicating mild stable systemic disease without functional limitations",
        "ASA III indicating severe systemic disease with substantive functional limitations",
        "ASA IV indicating severe systemic disease that constantly threatens life",
      ],
      correct: "B"
    },
    {
      id: 15490,
      question: "This patient's condition represents which ASA classification for dental treatment planning?",
      options: [
        "ASA II requiring routine dental care with standard precautions",
        "ASA III requiring caution and possible treatment modifications",
        "ASA IV requiring conservative emergency treatment only until stabilization",
        "ASA V indicating the patient is near death without intervention",
      ],
      correct: "B"
    },
    {
      id: 15491,
      question: "Direct observation signs of severe dental anxiety include all of the following EXCEPT:",
      options: [
        "Increased blood pressure and heart rate with overall appearance of uneasiness",
        "Trembling, excessive perspiration, and dilated pupils indicating distress",
        "Slow heart rate with decreased blood pressure indicating relaxation",
        "White-knuckle syndrome with unnaturally stiff posture and restlessness",
      ],
      correct: "C"
    },
    {
      id: 15492,
      question: "Stress reduction protocols should be applied during which timeframes?",
      options: [
        "Only during the actual dental procedure when anxiety typically peaks",
        "Before appointment, throughout treatment, and into postoperative period",
        "Exclusively before the appointment to prevent anxiety from developing",
        "After the appointment to address any anxiety that occurred during treatment",
      ],
      correct: "B"
    },
    {
      id: 15493,
      question: "The dental hygienist's immediate response should be to:",
      options: [
        "Continue treatment while monitoring for changes in patient responsiveness",
        "Terminate dental procedures and activate emergency medical services",
        "Wait 5 minutes to determine if consciousness returns spontaneously",
        "Administer supplemental oxygen and resume treatment after patient awakens",
      ],
      correct: "B"
    },
    {
      id: 15494,
      question: "The unconscious patient should be positioned in which position for emergency management?",
      options: [
        "Upright position to prevent aspiration and facilitate breathing",
        "Supine horizontal position with brain at same level as body",
        "Trendelenburg position with head lower than feet at 30 degrees",
        "Left lateral position to prevent tongue from blocking airway",
      ],
      correct: "B"
    },
    {
      id: 15495,
      question: "When providing information to the EMS dispatcher, the caller should hang up:",
      options: [
        "Immediately after providing the address to allow faster response time",
        "After describing patient condition but before EMS provides any instructions",
        "Only when the dispatcher indicates it is appropriate to disconnect",
        "Before providing patient information to maintain HIPAA compliance",
      ],
      correct: "C"
    },
    {
      id: 15496,
      question: "The first link in the chain of survival includes:",
      options: [
        "Advanced cardiac life support provided by hospital emergency personnel",
        "Early recognition of emergency and activation of emergency response system",
        "Immediate defibrillation within 1 minute of cardiac arrest onset",
        "Post-cardiac arrest care including rehabilitation and recovery support",
      ],
      correct: "B"
    },
    {
      id: 15497,
      question: "Each minute of delayed defibrillation reduces the patient's chance of survival by approximately:",
      options: [
        "1% making early defibrillation only moderately important",
        "5% indicating defibrillation should occur within 30 minutes",
        "10% emphasizing critical need for rapid defibrillation response",
        "25% but survival is possible even after extended delays",
      ],
      correct: "C"
    },
    {
      id: 15498,
      question: "For a responsive patient experiencing adrenal crisis, the hygienist should:",
      options: [
        "Place patient supine with feet elevated and assess oxygen saturation",
        "Place patient upright and administer bronchodilator via inhalation",
        "Immediately begin chest compressions and activate emergency services",
        "Encourage patient to walk around office to increase blood pressure",
      ],
      correct: "A"
    },
    {
      id: 15499,
      question: "This represents which type of airway obstruction requiring which management?",
      options: [
        "Complete obstruction requiring immediate Heimlich maneuver abdominal thrusts",
        "Partial obstruction with adequate air exchange; encourage continued coughing",
        "Severe obstruction requiring activation of EMS and chest compressions",
        "Mild obstruction requiring oxygen administration and patient repositioning",
      ],
      correct: "B"
    },
    {
      id: 15500,
      question: "Management of this complete airway obstruction includes:",
      options: [
        "Back blows delivered between shoulder blades five times rapidly",
        "Encouraging patient to cough forcefully to dislodge the obstruction",
        "Abdominal thrusts (Heimlich maneuver) until object is dislodged",
        "Immediate oxygen administration via nonrebreather mask at high flow",
      ],
      correct: "C"
    },
    {
      id: 15501,
      question: "For airway obstruction in a pregnant or obese patient, the hygienist should perform:",
      options: [
        "Abdominal thrusts (Heimlich maneuver) below the diaphragm as usual",
        "Chest compressions instead of abdominal thrusts until object dislodges",
        "Back blows only without any chest or abdominal compressions",
        "Finger sweeps to manually remove the obstruction from the airway",
      ],
      correct: "B"
    },
    {
      id: 15502,
      question: "For a patient with history of stable angina experiencing chest pain, the management includes:",
      options: [
        "Placing patient in comfortable position and administering sublingual nitroglycerin",
        "Immediately activating EMS and beginning cardiopulmonary resuscitation",
        "Administering high-dose aspirin and oxygen at maximum flow rate",
        "Continuing treatment while monitoring patient for worsening symptoms",
      ],
      correct: "A"
    },
    {
      id: 15503,
      question: "If angina pain is not relieved after three doses of nitroglycerin, the hygienist should:",
      options: [
        "Continue administering nitroglycerin every 5 minutes until pain resolves",
        "Wait 30 minutes before activating EMS to see if pain improves",
        "Activate EMS immediately and treat as myocardial infarction",
        "Administer epinephrine and bronchodilator to manage the emergency",
      ],
      correct: "C"
    },
    {
      id: 15504,
      question: "A patient with no history of angina who develops chest pain should be:",
      options: [
        "Given nitroglycerin sublingually and monitored for 15 minutes before EMS activation",
        "Treated the same as stable angina with three doses of medication",
        "Managed by immediately activating emergency medical services",
        "Placed in Trendelenburg position and given supplemental oxygen",
      ],
      correct: "C"
    },
    {
      id: 15505,
      question: "Initial management of an asthma attack includes positioning the patient:",
      options: [
        "In supine position to maximize blood flow to brain and organs",
        "In upright position to facilitate breathing and reduce respiratory effort",
        "In left lateral position to prevent aspiration of secretions",
        "In Trendelenburg position with feet elevated above heart level",
      ],
      correct: "B"
    },
    {
      id: 15506,
      question: "If asthma symptoms do not improve after bronchodilator use, the hygienist should:",
      options: [
        "Continue dental treatment as planned while monitoring patient status",
        "Have patient use inhaler again, administer oxygen, and activate EMS",
        "Wait 1 hour before determining if emergency services are needed",
        "Administer sublingual nitroglycerin to dilate airways and improve breathing",
      ],
      correct: "B"
    },
    {
      id: 15507,
      question: "For an unresponsive patient with severe asthma attack, which medication should be administered?",
      options: [
        "Nitroglycerin 0.4 mg sublingually to dilate blood vessels",
        "Aspirin 325 mg chewed to prevent thrombosis formation",
        "Epinephrine 0.3 mg of 1:1000 intramuscularly or subcutaneously",
        "Diphenhydramine 50 mg orally to reduce allergic response",
      ],
      correct: "C"
    },
    {
      id: 15508,
      question: "Immediate management of cardiac arrest includes:",
      options: [
        "Waiting for emergency personnel before beginning any interventions",
        "Administering oxygen and monitoring for spontaneous return of pulse",
        "Placing patient supine, activating EMS, and initiating BLS immediately",
        "Giving sublingual nitroglycerin and aspirin before starting compressions",
      ],
      correct: "C"
    },
    {
      id: 15509,
      question: "These signs and symptoms most likely indicate which medical emergency?",
      options: [
        "Hypoglycemia requiring immediate administration of oral glucose",
        "Cerebrovascular accident (stroke) requiring immediate EMS activation",
        "Hyperventilation syndrome requiring breathing into cupped hands",
        "Syncope requiring supine positioning with elevated feet",
      ],
      correct: "B"
    },
    {
      id: 15510,
      question: "A patient experiencing a stroke should be positioned in which position?",
      options: [
        "Supine position to maximize cerebral blood flow and perfusion",
        "Upright position to reduce intracranial pressure from bleeding",
        "Semisupine position while maintaining airway and activating EMS",
        "Prone position to prevent aspiration of secretions or vomitus",
      ],
      correct: "C"
    },
    {
      id: 15511,
      question: "Immediate management of a chemical burn to the eye includes:",
      options: [
        "Applying antibiotic ointment and covering eye with sterile patch",
        "Immediately flushing eye mesially to distally with water for 15 minutes",
        "Having patient keep eye closed and wait for ophthalmologist evaluation",
        "Removing chemical with cotton-tipped applicator before irrigation",
      ],
      correct: "B"
    },
    {
      id: 15512,
      question: "Management of a foreign particle in the eye includes:",
      options: [
        "Using cotton-tipped applicator to manually remove the particle directly",
        "Rinsing eye mesially to distally or having patient lift upper eyelid over lower",
        "Applying pressure patch over closed eye until particle works out naturally",
        "Administering topical anesthetic drops before attempting particle removal",
      ],
      correct: "B"
    },
    {
      id: 15513,
      question: "To control hemorrhage from a dental extraction site, the hygienist should:",
      options: [
        "Apply ice externally and wait for bleeding to stop spontaneously",
        "Have patient rinse vigorously with cold water to promote clotting",
        "Pack area with gauze and have patient bite down until bleeding stops",
        "Immediately suture the site to achieve hemostasis and control bleeding",
      ],
      correct: "C"
    },
    {
      id: 15514,
      question: "This blood pressure reading represents which condition requiring which management?",
      options: [
        "Normal blood pressure requiring no intervention or treatment modifications",
        "Hypertensive urgency requiring immediate medical assessment and care",
        "Hypertensive emergency requiring immediate reduction to prevent organ damage",
        "Isolated systolic hypertension requiring beta-blocker administration",
      ],
      correct: "B"
    },
    {
      id: 15515,
      question: "This represents hypertensive emergency requiring which immediate action?",
      options: [
        "Advising patient to see their physician within the next month",
        "Having patient rest quietly and rechecking blood pressure in 15 minutes",
        "Activating EMS or facilitating transfer to advanced care setting immediately",
        "Administering sublingual nitroglycerin to rapidly lower blood pressure",
      ],
      correct: "C"
    },
    {
      id: 15516,
      question: "These symptoms most likely indicate which condition?",
      options: [
        "Hyperventilation syndrome due to excessive loss of carbon dioxide",
        "Myocardial infarction requiring aspirin and nitroglycerin administration",
        "Asthma attack requiring bronchodilator and oxygen administration",
        "Anaphylaxis requiring immediate epinephrine administration",
      ],
      correct: "A"
    },
    {
      id: 15517,
      question: "A hyperventilating patient should be managed by implementing which interventions?",
      options: [
        "Administering high-flow oxygen via nonrebreather mask immediately",
        "Having patient breathe through pursed lips or into cupped hands",
        "Placing patient in supine position with legs elevated above heart",
        "Administering epinephrine and activating emergency medical services",
      ],
      correct: "B"
    },
    {
      id: 15518,
      question: "The chest pain is most likely caused by:",
      options: [
        "Angina pectoris that will resolve with sublingual nitroglycerin",
        "Hyperventilation that will improve with breathing techniques",
        "Myocardial infarction requiring immediate emergency intervention",
        "Anxiety that will resolve with reassurance and stress reduction",
      ],
      correct: "C"
    },
    {
      id: 15519,
      question: "A patient experiencing possible myocardial infarction should receive which medication?",
      options: [
        "325 mg of chewable, non-enteric-coated aspirin chewed immediately",
        "Three doses of sublingual nitroglycerin spaced 5 minutes apart",
        "Bronchodilator inhaler to improve oxygen delivery to tissues",
        "Antihistamine to reduce inflammatory response in cardiac tissue",
      ],
      correct: "A"
    },
    {
      id: 15520,
      question: "A patient with suspected myocardial infarction should be positioned:",
      options: [
        "In supine position with legs elevated to maximize cardiac output",
        "In comfortable position, usually semisupine or upright as tolerated",
        "In Trendelenburg position to increase venous return to heart",
        "In prone position to reduce cardiac workload and oxygen demand",
      ],
      correct: "B"
    },
    {
      id: 15521,
      question: "These symptoms most likely indicate:",
      options: [
        "Asthma attack requiring bronchodilator administration",
        "Hyperventilation requiring breathing into cupped hands",
        "Acute pulmonary edema requiring upright positioning",
        "Myocardial infarction requiring aspirin administration",
      ],
      correct: "C"
    },
    {
      id: 15522,
      question: "A patient with acute pulmonary edema should receive which medication?",
      options: [
        "Bronchodilator via inhalation to dilate airways",
        "Sublingual nitroglycerin 0.8-1.2 mg every 5-10 minutes",
        "Oral antihistamine to reduce inflammatory response",
        "Chewable aspirin to prevent thrombus formation",
      ],
      correct: "B"
    },
    {
      id: 15523,
      question: "These signs most likely indicate which condition?",
      options: [
        "Hyperventilation requiring slow breathing through pursed lips",
        "Psychogenic shock requiring supine position with elevated feet",
        "Myocardial infarction requiring chewable aspirin administration",
        "Hyperglycemia requiring patient to self-administer insulin",
      ],
      correct: "B"
    },
    {
      id: 15524,
      question: "The most common cause of sudden loss of consciousness in dental settings is:",
      options: [
        "Myocardial infarction with complete cessation of cardiac function",
        "Cerebrovascular accident with intracranial hemorrhage",
        "Syncope with transient loss of consciousness from cerebral hypoxia",
        "Diabetic coma with severe hyperglycemia and ketoacidosis",
      ],
      correct: "C"
    },
    {
      id: 15525,
      question: "An unconscious syncopal patient should be managed by which immediate intervention?",
      options: [
        "Placing patient supine with legs slightly elevated and assessing airway",
        "Administering ammonia inhalants under nose to stimulate consciousness",
        "Beginning chest compressions at 100-120 per minute immediately",
        "Giving patient oral glucose while maintaining upright position",
      ],
      correct: "A"
    },
    {
      id: 15526,
      question: "A pregnant patient who lost consciousness should be positioned:",
      options: [
        "In supine position with legs elevated above heart level",
        "In upright position to prevent aspiration of secretions",
        "Rolled onto left side rather than flat supine position",
        "In prone position with head turned to side for airway",
      ],
      correct: "C"
    },
    {
      id: 15527,
      question: "If consciousness is not rapidly regained after proper positioning, the hygienist should:",
      options: [
        "Continue monitoring and wait 15 minutes before taking further action",
        "Administer ammonia inhalants repeatedly until patient awakens",
        "Activate emergency medical services immediately for advanced care",
        "Begin chest compressions even if pulse is present and adequate",
      ],
      correct: "C"
    },
    {
      id: 15528,
      question: "This represents which type of seizure disorder?",
      options: [
        "Nonconvulsive petit mal seizure with momentary loss of awareness",
        "Generalized tonic-clonic grand mal seizure requiring protective positioning",
        "Focal partial seizure affecting only one area of the body",
        "Absence seizure with brief blank stare lasting several seconds",
      ],
      correct: "B"
    },
    {
      id: 15529,
      question: "During a generalized tonic-clonic seizure, the hygienist should:",
      options: [
        "Restrain patient firmly to prevent injury from involuntary movements",
        "Place tongue blade between teeth to prevent tongue biting",
        "Lower dental chair and protect patient from injury without restraining",
        "Administer high-flow oxygen and epinephrine immediately",
      ],
      correct: "C"
    },
    {
      id: 15530,
      question: "After a seizure resolves, the hygienist should:",
      options: [
        "Immediately resume dental treatment once patient regains consciousness",
        "Monitor airway, assess oxygen saturation, and allow patient to rest",
        "Administer oral glucose to prevent hypoglycemia-induced seizures",
        "Have patient walk around to improve circulation and consciousness",
      ],
      correct: "B"
    },
    {
      id: 15531,
      question: "These symptoms most likely indicate:",
      options: [
        "Hyperglycemia with excess glucose and insufficient insulin",
        "Hypoglycemia with insufficient glucose requiring rapid intervention",
        "Diabetic ketoacidosis requiring insulin administration",
        "Hyperosmolar hyperglycemic state requiring hospitalization",
      ],
      correct: "B"
    },
    {
      id: 15532,
      question: "A responsive patient experiencing hypoglycemia should receive:",
      options: [
        "Patient's own insulin to lower blood glucose to normal levels",
        "Intramuscular glucagon to stimulate glucose release from liver",
        "Concentrated oral sugar such as juice or glucose tablets",
        "High-flow oxygen via nonrebreather mask immediately",
      ],
      correct: "C"
    },
    {
      id: 15533,
      question: "An unconscious diabetic patient should receive which intervention?",
      options: [
        "Oral glucose placed between cheek and gum for absorption",
        "Intramuscular or subcutaneous glucagon 1 mg if available and trained",
        "Patient's own insulin subcutaneously to reduce blood glucose",
        "Fruit juice given slowly by spoon to prevent aspiration",
      ],
      correct: "B"
    },
    {
      id: 15534,
      question: "These signs and symptoms indicate:",
      options: [
        "Hypoglycemia requiring immediate administration of oral glucose",
        "Hyperglycemia requiring activation of EMS and oxygen as needed",
        "Anaphylaxis requiring immediate epinephrine administration",
        "Adrenal crisis requiring supine positioning with feet elevated",
      ],
      correct: "B"
    },
    {
      id: 15535,
      question: "These symptoms represent which condition requiring immediate management?",
      options: [
        "Localized allergic reaction requiring oral antihistamine administration",
        "Anaphylaxis requiring immediate epinephrine and EMS activation",
        "Hyperventilation requiring slow breathing through pursed lips",
        "Vasovagal syncope requiring supine positioning with elevated legs",
      ],
      correct: "B"
    },
    {
      id: 15536,
      question: "A responsive patient experiencing anaphylaxis should be positioned:",
      options: [
        "In supine position with legs elevated to maximize blood pressure",
        "In comfortable position, usually upright, before administering epinephrine",
        "In Trendelenburg position with head lower than feet",
        "In left lateral position to prevent aspiration of secretions",
      ],
      correct: "B"
    },
    {
      id: 15537,
      question: "The appropriate epinephrine dose for anaphylaxis in a 40 kg adult is:",
      options: [
        "0.15 mg intramuscularly as this patient weighs less than 30 kg",
        "0.3 to 0.5 mg intramuscularly as this patient weighs greater than 30 kg",
        "1.0 mg intravenously to rapidly reverse severe anaphylaxis",
        "0.01 mg subcutaneously to minimize cardiovascular side effects",
      ],
      correct: "B"
    },
    {
      id: 15538,
      question: "If anaphylaxis symptoms persist after initial epinephrine, the hygienist should:",
      options: [
        "Wait 30 minutes before considering additional interventions",
        "Switch to oral antihistamine instead of additional epinephrine",
        "Consider repeat epinephrine dose if advanced care won't arrive within 5-10 minutes",
        "Administer bronchodilator inhaler rather than additional epinephrine",
      ],
      correct: "C"
    },
    {
      id: 15539,
      question: "This represents which type of allergic reaction requiring which management?",
      options: [
        "Anaphylaxis requiring immediate intramuscular epinephrine administration",
        "Localized skin response requiring oral diphenhydramine administration",
        "Severe allergic reaction requiring EMS activation and oxygen administration",
        "Hyperventilation requiring breathing exercises and reassurance",
      ],
      correct: "B"
    },
    {
      id: 15540,
      question: "The appropriate diphenhydramine dose for a localized allergic reaction in adults is:",
      options: [
        "10 mg orally to minimize sedation side effects",
        "25 to 50 mg orally with physician consultation for repeat doses",
        "100 mg orally for maximum antihistamine effect",
        "5 mg intravenously for rapid absorption and effect",
      ],
      correct: "B"
    },
    {
      id: 15541,
      question: "These symptoms most likely indicate:",
      options: [
        "Anaphylactic reaction to local anesthetic requiring epinephrine",
        "Vasovagal syncope requiring supine positioning with elevated feet",
        "Toxicity from local anesthetic requiring supportive care and monitoring",
        "Hyperventilation requiring breathing into cupped hands or bag",
      ],
      correct: "C"
    },
    {
      id: 15542,
      question: "These symptoms indicate toxicity from which component?",
      options: [
        "Local anesthetic agent causing central nervous system depression",
        "Vasoconstrictor or vasopressor causing cardiovascular stimulation",
        "Preservative in anesthetic solution causing allergic response",
        "Latex from anesthetic carpule causing anaphylactic reaction",
      ],
      correct: "B"
    },
    {
      id: 15543,
      question: "The ideal immediate management of tooth avulsion is to:",
      options: [
        "Immediately reimplant the tooth into the socket at the scene",
        "Store tooth in tap water until professional care is available",
        "Scrub tooth vigorously with soap to remove debris before reimplanting",
        "Wrap tooth in dry gauze and transport to emergency department",
      ],
      correct: "A"
    },
    {
      id: 15544,
      question: "If immediate reimplantation of an avulsed tooth is not possible, the tooth should be:",
      options: [
        "Stored in tap water until professional dental care is available",
        "Wrapped in dry gauze to protect during transport to dentist",
        "Stored in Hanks' balanced salt solution or wrapped in cling film",
        "Placed in alcohol solution to sterilize before reimplantation",
      ],
      correct: "C"
    },
    {
      id: 15545,
      question: "The individual designated to monitor the emergency kit should check contents:",
      options: [
        "Annually and after every emergency situation that occurs in office",
        "Quarterly at minimum and after every emergency requiring kit use",
        "Monthly during active practice months and semi-annually during slow periods",
        "Only when staff members notice items are missing or expired",
      ],
      correct: "B"
    },
    {
      id: 15546,
      question: "At minimum, every dental facility should have all of the following EXCEPT:",
      options: [
        "First aid kit, emergency drug kit, portable oxygen, and AED",
        "Advanced life support medications for intravenous administration",
        "Pulse oximeter, blood pressure cuff, and stethoscope",
        "Pocket mask or bag-valve-mask for rescue breathing",
      ],
      correct: "B"
    },
    {
      id: 15547,
      question: "Dental hygienists should have their own resuscitation masks in treatment areas to ensure:",
      options: [
        "Masks are always available during patient care for potential emergencies",
        "Hygienists can avoid using practice-owned emergency equipment",
        "Individual hygienists are solely responsible for emergency management",
        "Contaminated masks can be assigned to specific patients for reuse",
      ],
      correct: "A"
    },
    {
      id: 15548,
      question: "Emergency protocols should be reviewed with all staff members at which intervals?",
      options: [
        "Every 5 years when BLS certifications expire and require renewal",
        "Only when new employees are hired and oriented to facility",
        "At least annually with simulations to ensure staff preparedness",
        "Monthly during staff meetings to maintain constant awareness",
      ],
      correct: "C"
    },
    {
      id: 15549,
      question: "The maximum oxygen flow rate via nasal cannula should not exceed:",
      options: [
        "2 liters per minute to prevent drying of nasal mucosa",
        "6 liters per minute when titrating up for adequate saturation",
        "10 liters per minute to achieve maximum oxygen delivery",
        "15 liters per minute for critically ill patients requiring support",
      ],
      correct: "B"
    },
    {
      id: 15550,
      question: "For acutely ill patients with difficulty breathing, the target oxygen saturation is:",
      options: [
        "85-90% to prevent oxygen toxicity from excessive administration",
        "90-94% which is adequate for most clinical situations",
        "94-98% for patients showing obvious signs of distress",
        "100% to maximize oxygen delivery to all tissues",
      ],
      correct: "C"
    },
    {
      id: 15551,
      question: "Recent research indicates oxygen administration should be:",
      options: [
        "Used routinely for nearly every medical emergency except hyperventilation",
        "Titrated appropriately based on pulse oximetry rather than given routinely",
        "Avoided completely as oxygen causes more harm than benefit",
        "Given at maximum flow rates to all patients experiencing emergencies",
      ],
      correct: "B"
    },
    {
      id: 15552,
      question: "Basic Life Support continues until which endpoint is reached?",
      options: [
        "The patient recovers, is stabilized and transported, or advanced support arrives",
        "Exactly 10 minutes have elapsed from initiation of resuscitation efforts",
        "Family members arrive and request discontinuation of resuscitation",
        "Dental staff members become fatigued and unable to continue compressions",
      ],
      correct: "A"
    },
    {
      id: 15553,
      question: "Each member of the dental team should have which role during emergencies?",
      options: [
        "All team members should perform the same tasks simultaneously",
        "Specific predetermined roles that are reviewed and practiced periodically",
        "Flexible roles determined spontaneously based on patient needs",
        "Minimal involvement with most care provided by single team leader",
      ],
      correct: "B"
    },
    {
      id: 15554,
      question: "Current evidence indicates ammonia inhalants for unconscious patients:",
      options: [
        "Are essential for treating all cases of syncope in dental settings",
        "Should be used as first-line treatment before other interventions",
        "Are no longer recommended due to potential complications and harm",
        "Must be used within 30 seconds of unconsciousness for effectiveness",
      ],
      correct: "C"
    },
    {
      id: 15555,
      question: "Good Samaritan statutes generally provide immunity from civil liability when:",
      options: [
        "Any healthcare professional provides care regardless of circumstances",
        "Emergency care is provided at scene, person is trained, and acts gratuitously",
        "Care is provided in exchange for payment or expectation of compensation",
        "Gross negligence or willful misconduct occurs during emergency care",
      ],
      correct: "B"
    },
    {
      id: 15556,
      question: "Good Samaritan protection would NOT apply if:",
      options: [
        "The emergency care is provided at the scene of the emergency",
        "The healthcare professional has proper training for care provided",
        "The volunteer acts gratuitously expecting remuneration for services",
        "The person rendered aid to an injured stranger on voluntary basis",
      ],
      correct: "C"
    },
    {
      id: 15557,
      question: "A dental hygienist has a duty to deliver emergency services when:",
      options: [
        "Providing emergency care is part of the person's job responsibilities",
        "The emergency occurs outside the dental office during off hours",
        "The injured person is a family member or close personal friend",
        "Payment is guaranteed before any emergency services are rendered",
      ],
      correct: "A"
    },
    {
      id: 15558,
      question: "If a patient is conscious during a medical emergency:",
      options: [
        "Consent is assumed and emergency assistance can begin immediately",
        "Consent must be expressly obtained before providing any assistance",
        "No consent is required as emergency situations override normal protocols",
        "Only verbal consent is needed as written consent takes too much time",
      ],
      correct: "B"
    },
    {
      id: 15559,
      question: "When a patient is unconscious and unable to consent to treatment:",
      options: [
        "No emergency treatment can be provided until family gives permission",
        "Permission can be assumed and emergency assistance begins immediately",
        "Dental professionals must wait for EMS personnel to provide consent",
        "Treatment can only include basic first aid without advanced interventions",
      ],
      correct: "B"
    },
    {
      id: 15560,
      question: "Magnetized retrieval instruments such as periotrievers are used to:",
      options: [
        "Remove all types of instrument tips regardless of metal composition",
        "Sterilize contaminated instruments before reuse on subsequent patients",
        "Retrieve broken instrument tips though may not work on all metals",
        "Measure the magnetic field around electronic dental equipment",
      ],
      correct: "C"
    },
    {
      id: 15561,
      question: "Whenever possible during emergencies, conscious patients should be encouraged to:",
      options: [
        "Wait for dental professionals to administer all medications for safety",
        "Self-administer their own medications such as inhalers or EpiPens",
        "Avoid taking any medications until EMS personnel arrive and evaluate",
        "Share their medications with other patients experiencing similar symptoms",
      ],
      correct: "B"
    },
    {
      id: 15562,
      question: "To prevent medical emergencies, patients should be encouraged to:",
      options: [
        "Skip all medications on days when dental appointments are scheduled",
        "Double medication doses before appointments to prevent emergencies",
        "Comply with prescribed medication schedules and take medications regularly",
        "Stop all medications one week before dental appointments to prevent interactions",
      ],
      correct: "C"
    },
    {
      id: 15563,
      question: "Every dental emergency kit should include which monitoring equipment?",
      options: [
        "Electrocardiogram machine to record electrical cardiac activity",
        "Blood pressure cuff, stethoscope, and pulse oximeter for monitoring",
        "Advanced pulse wave analysis equipment for cardiac output measurement",
        "Capnography monitor to measure end-tidal carbon dioxide levels",
      ],
      correct: "B"
    },
    {
      id: 15564,
      question: "When vital signs are recorded outside normal ranges, the hygienist should:",
      options: [
        "Proceed with treatment as planned since vital signs often normalize",
        "Discuss findings with patient and consult physician if treatment modification needed",
        "Refuse to treat the patient permanently and refer to hospital for care",
        "Ignore findings if patient reports feeling normal despite abnormal readings",
      ],
      correct: "B"
    },
    {
      id: 15565,
      question: "Recognition of patient anxiety can be accomplished by:",
      options: [
        "Asking directly about fear, anxiety, and past experiences during health history",
        "Assuming all patients have similar anxiety levels regardless of statements",
        "Waiting until emergency situations occur before assessing anxiety levels",
        "Ignoring patient statements since anxiety cannot be reliably assessed",
      ],
      correct: "A"
    },
    {
      id: 15566,
      question: "Pharmacologic options for stress reduction may include:",
      options: [
        "Long-acting benzodiazepines taken one week before the appointment",
        "Short-acting benzodiazepine premedication or nitrous oxide during appointment",
        "Antibiotic prophylaxis to reduce anxiety about post-treatment infections",
        "Opioid analgesics taken 24 hours before scheduled appointment",
      ],
      correct: "B"
    },
    {
      id: 15567,
      question: "Which represents an appropriate non-pharmacologic technique for managing dental anxiety?",
      options: [
        "Distraction, relaxation techniques, and cognitive therapy approaches",
        "Physical restraint to prevent patient movement during procedures",
        "Ignoring patient concerns to avoid reinforcing anxiety behaviors",
        "Extending appointment times to 3 hours to complete all treatment",
      ],
      correct: "A"
    },
    {
      id: 15568,
      question: "Scheduling short morning appointments represents which aspect of stress reduction?",
      options: [
        "Pharmacologic intervention requiring prescription medications",
        "General stress-reduction protocol to minimize patient anxiety",
        "Advanced sedation technique requiring special training",
        "Inappropriate accommodation that reinforces avoidance behavior",
      ],
      correct: "B"
    },
    {
      id: 15569,
      question: "Patient health history and risk assessment should be completed and updated:",
      options: [
        "Only at initial appointment and never needs updating in future",
        "Every 5 years or when patient volunteers changes have occurred",
        "At initial appointment and updated at each subsequent visit",
        "Only when patient appears to be experiencing medical emergency",
      ],
      correct: "C"
    },
    {
      id: 15570,
      question: "This patient cannot climb stairs or walk two blocks without stopping to rest. This represents:",
      options: [
        "ASA I classification indicating normal health and minimal risk",
        "ASA II classification indicating mild stable systemic disease",
        "ASA III classification indicating severe disease with functional limitations",
        "ASA IV classification indicating disease constantly threatening life",
      ],
      correct: "C"
    },
    {
      id: 15571,
      question: "This condition represents which ASA classification?",
      options: [
        "ASA II as kidney disease is managed with conservative treatment",
        "ASA III as dialysis can be scheduled when needed for treatment",
        "ASA IV as severe disease constantly threatens life without dialysis",
        "ASA V as patient is near death without dialysis intervention",
      ],
      correct: "C"
    },
    {
      id: 15572,
      question: "A patient experiencing acute pulmonary edema should be positioned:",
      options: [
        "Supine with legs elevated to maximize venous return to heart",
        "Upright to reduce fluid accumulation in lungs and ease breathing",
        "Prone to allow drainage of fluid from lungs by gravity",
        "Left lateral position to prevent aspiration of frothy sputum",
      ],
      correct: "B"
    },
    {
      id: 15573,
      question: "A patient experiencing hyperventilation should receive oxygen therapy:",
      options: [
        "At maximum flow rate to correct respiratory alkalosis quickly",
        "At moderate flow rate to achieve target saturation levels",
        "Through nonrebreather mask to deliver highest oxygen concentration",
        "Not at all as oxygen would worsen respiratory alkalosis",
      ],
      correct: "D"
    },
    {
      id: 15574,
      question: "Status epilepticus requires which immediate intervention?",
      options: [
        "Continuing to protect patient and wait for seizure to stop spontaneously",
        "Restraining patient firmly to prevent injury from violent movements",
        "Activating emergency medical services for advanced seizure management",
        "Administering oral glucose to treat potential hypoglycemia cause",
      ],
      correct: "C"
    },
    {
      id: 15575,
      question: "During a medical emergency, which team member should be assigned documentation responsibilities?",
      options: [
        "The person performing CPR chest compressions on patient",
        "A designated team member recording information on incident report form",
        "The dentist who is managing the patient's airway",
        "No one should document until after emergency is completely resolved",
      ],
      correct: "B"
    }
  ]
};
